import { UserComponent } from './../setting/UserManagement/user/user.component';
//===========================================================================//
//=================================> English <==============================//
//=========================================================================//

import * as globalsEnJson from "./Resources/global-en.json";
import * as dashboardEnJson from "./Resources/Dashboard/dashboard-en.json";
import * as visitorsEnJson from "./Resources/VisitorManagement/visitors/visitors-en.json";
import * as activityLogsEnJson from "./Resources/Activity-Logs/activity-Logs-en.json";
import * as addAssetEnJson from "./Resources/asset management/add asset/add-asset-en.json";
import * as assetDetailEnJson from "./Resources/asset management/asset detail/asset-detail-en.json";
import * as assetsEnJson from "./Resources/asset management/asset-en.json";
import * as attendanceListEnJson from "./Resources/Attendance/Attendance-List/attendance-list-en.json";
import * as attendanceViewEnJson from "./Resources/Attendance/Attendance-View/attendance-View-en.json";
import * as bookingEnJson from "./Resources/Bookings/Booking/booking-en.json";
import * as bookingsEnJson from "./Resources/Bookings/Bookings/bookings-en.json";
import * as bookingSlotEnJson from "./Resources/bookingSlots/booking-slot/booking-slot-en.json";
import * as bookingSlotsEnJson from "./Resources/bookingSlots/booking-slots/booking-slots-en.json";
import * as addEmployeeEnJson from "./Resources/employees/add Employee/add-employee-en.json";
import * as employeesListingEnJson from "./Resources/employees/employees listing/employees-listing-en.json";
import * as addEnquiryEnJson from "./Resources/enquiry/add enquiry/add-enquiry-en.json";
import * as enquiryListingEnJson from "./Resources/enquiry/enquiry listing/enquiry-listing-en.json";
import * as feeEnJson from "./Resources/Fee Management/Fee/fee-en.json";
import * as feesEnJson from "./Resources/Fee Management/Fees/fees-en.json";
import * as paySalaryToEmployeesEnJson from "./Resources/hr-pay-management/components/pay-salary-to-employees-en.json";
import * as designationManagementEnJson from "./Resources/hr-pay-management/designation-management/designation-management-en.json";
import * as employeeSalaryManagementEnJson from "./Resources/hr-pay-management/employee-salary-management/employee-salary-management-en.json";
import * as addMembersEnJson from "./Resources/members/add-members/add-members-en.json";
import * as cameraEnJson from "./Resources/members/camera/camera-en.json";
import * as addFeeEnJson from "./Resources/members/components/add-fee/add-fee-en.json";
import * as addFeeMemberEnJson from "./Resources/members/components/add-fee-member/add-fee-member-en.json";
import * as bookTrainerEnJson from "./Resources/members/components/book-trainer/book-trainer-en.json";
import * as sessionAttendanceReportEnJson from "./Resources/session-attendance-report/session-attendance-report-en.json";
import * as sessionSalesReportEnJson from "./Resources/session-sales-report/session-sales-report-en.json";
import * as sessionAttendanceEnJson from "./Resources/session-attendance/session-attendance-en.json";
import * as appPasswordEnJson from "./Resources/members/components/aap-password/app-password-en.json";
import * as exportDataEnJson from "./Resources/members/components/export-data/export-data-en.json";
import * as feesInvoiceEnJson from "./Resources/members/components/fees-invoice/fees-invoice-en.json";
import * as emailConfirmationModelEnJson from "./Resources/members/email-confirmation-model/email-confirmation-model-en.json";
import * as inactiveMembersEnJson from "./Resources/members/inactive-members/inactive-members-en.json";
import * as membersEnJson from "./Resources/members/members/members-en.json";
import * as packageBuilderEnJson from "./Resources/packageBuilder/packageBuilder/package-builder-en.json";
import * as packageBuildersEnJson from "./Resources/packageBuilder/packageBuilders/package-builders-en.json";
import * as pettyCashEnJson from "./Resources/petty-cash/petty-cash-en.json";
import * as addProductEnJson from "./Resources/products/add products/add-product-en.json";
import * as productCategoriesEnJson from "./Resources/products/product categories/product-categories-en.json";
import * as productCategoryEnJson from "./Resources/products/product category/product-category-en.json";
import * as productsListingEnJson from "./Resources/products/product listing/product-listing-en.json";
import * as updateStockCountEnJson from "./Resources/products/update stock count/update-stock-count-en.json";
import * as contactUsEnJson from "./Resources/public/contact us/contact-us-en.json";
import * as loginLogsEnJson from "./Resources/public/login logs/login-logs-en.json";
import * as activeMemberReportEnJson from "./Resources/reports/active member report/active-member-report-en.json";
import * as attendenceReportEnJson from "./Resources/reports/attendance report/attendance-report-en.json";
import * as checkInReportEnJson from "./Resources/reports/check in report/check-in-report-en.json";
import * as dailyClosingReportEnJson from "./Resources/reports/daily closing report/daily-closing-report-en.json";
import * as defaulterReportEnJson from "./Resources/reports/defaulter report/defaulter-report-en.json";
import * as newMemberReportEnJson from "./Resources/reports/new member report/new-member-report-en.json";
import * as memberReportEnJson from "./Resources/reports/member report/member-report-en.json";
import * as pOSSalesReportEnJson from "./Resources/reports/pos sales report/pos-sales-report-en.json";
import * as purchaseHistoryReportsEnJson from "./Resources/reports/purchase history report/purchase-history-report-en.json";
import * as requestManagementReportsEnJson from "./Resources/reports/request management report/request-management-report-en.json";
import * as salesReportsEnJson from "./Resources/reports/sales report/sales-report-en.json";
import * as trainerSalesReportEnJson from "./Resources/reports/trainer sales report/trainer-sales-report-en.json";
import * as trainerClientsReportEnJson from "./Resources/reports/trainer clients report/trainer-clients-report-en.json";
import * as trainerSessionReportEnJson from "./Resources/reports/trainer session report/trainer-session-report-en.json";
import * as trainingAttendenceReportEnJson from "./Resources/reports/training attendence report/training-attendence-report-en.json";
import * as upcomingBirthdaysReportEnJson from "./Resources/reports/upcoming birthdays/upcoming-birthdays-report-en.json";
import * as upcomingDuesReportEnJson from "./Resources/reports/upcoming dues report/upcoming-dues-report-en.json";
import * as usersAttendanceReportEnJson from "./Resources/reports/users attendance report/users-attendance-report-en.json";
import * as reportsEnJson from "./Resources/reports/billing report/billing-report-en.json";
import * as feeSubmissionRequestDetailEnJson from "./Resources/request management/components/fee submission request detail/fee-submission-request-detail-en.json";
import * as memberRequestDetailEnJson from "./Resources/request management/components/member request detail/member-request-detail-en.json";
import * as requestsManagementEnJson from "./Resources/request management/request management/request-management-en.json";
import * as pointOfSaleEnJson from "./Resources/Sales/point of sale/point-of-sale-en.json";
import * as saleOrdersEnJson from "./Resources/Sales/sale orders/sale-orders-en.json";
import * as branchEnJson from "./Resources/setting/branch management/branch/branch-en.json";
import * as branchesEnJson from "./Resources/setting/branch management/branches/branches-en.json";
import * as registerBranchFromCompanyEnJson from "./Resources/setting/branch management/register-branch-from-company/register-branch-from-company-en.json";
import * as companiesEnJson from "./Resources/setting/company management/companies/companies-en.json";
import * as companyEnJson from "./Resources/setting/company management/company/company-en.json";
import * as userPasswordEnJson from "./Resources/setting/user password/user-password-en.json";
import * as permissionEnJson from "./Resources/setting/permission management/Permission/permission-en.json";
import * as permissionsEnJson from "./Resources/setting/permission management/Permissions/permissions-en.json";
import * as roleEnJson from "./Resources/setting/role management/role/role-en.json";
import * as rolesEnJson from "./Resources/setting/role management/roles/roles-en.json";
import * as userEnJson from "./Resources/setting/user management/user/user-en.json";
import * as trainerPackagesEnJson from "./Resources/setting/user management/trainer-packages/trainer-packages-en.json";
import * as trainerScheduleEnJson from "./Resources/setting/user management/trainer-schedule/trainer-schedule-en.json";
import * as trainerModuleSettingsEnJson from "./Resources/setting/branch management/trainer-module-settings/trainer-module-settings-en.json";
import * as usersEnJson from "./Resources/setting/user management/users/users-en.json";
import * as receiptPrintEnJson from "./Resources/shared/receipt/receipt print/receipt-print-en.json";
import * as singleReceiptPrintEnJson from "./Resources/shared/receipt/single receipt print/single-receipt-print-en.json";
import * as singleReceiptEmailEnJson from "./Resources/shared/receipt/single receipt email/single-receipt-email-en.json";
import * as signupEnJson from "./Resources/shared/signup/signup-en.json";
import * as addSingleSignupEnJson from "./Resources/shared/signup/add single signup/add-single-signup-en.json";
import * as addMultipleSignupEnJson from "./Resources/shared/signup/add multiple signup/add-multiple-signup-en.json";
import * as inActiveMemberReportEnJson from "./Resources/reports/inactive member report/inactive-member-report-en.json";
import * as enquiryManagementReportEnJson from "./Resources/reports/enquiry management report/enquiry-management-report-en.json";
import * as addSupplierEnJson from "./Resources/supplier/add supplier/add-supplier-en.json";
import * as purchaseOrderEnJson from "./Resources/supplier/purchase order/purchase-order-en.json";
import * as purchaseOrdersEnJson from "./Resources/supplier/purchase orders/puchase-orders-en.json";
import * as supplierListingEnJson from "./Resources/supplier/supplier listing/supplier-listing-en.json";
import * as membersTrainingAttendanceEnJson from "./Resources/trainer/members training attendance/members-training-attendance-en.json";
import * as membersTrainingAttendanceViewEnJson from "./Resources/trainer/members training attendance view/members-training-attendance-view-en.json";
import * as addVisitorEnJson from "./Resources/VisitorManagement/addVisitor/add-visitor-en.json";
import * as visitorDialogueEnJson from "./Resources/VisitorManagement/Independent Visitor/independent-visitor-en.json";
import * as visitorRequestDetailEnJson from "./Resources/request management/components/visitor request detail/visitor-request-detail-en.json";
import * as freezeRequestDetailEnJson from "./Resources/request management/components/freeze request detail/freeze-request-detail-en.json";
import * as visitorReportEnJson from "./Resources/reports/visitor report/visitor-report-en.json";
import * as globalEnJson from "./Resources/global/global-en.json";
import * as closingReportEnJson from "./Resources/reports/closing report/closing-report-en.json";
import * as userInformationEnJson from "./Resources/pages/user information/user-information-en.json";
import * as notificationEnJson from "./Resources/notification center/notification/notification-en.json";
import * as notificationsEnJson from "./Resources/notification center/notifications/notifications-en.json";
import * as addTrainerEnJson from "./Resources/trainer/add trainer/add-trainer-en.json";
import * as trainersEnJson from "./Resources/trainer/trainers/trainers-en.json";
import * as appFormFieldsEnJson from "./Resources/global/app form fields/app-form-fields-en.json";
import * as trainerAttendanceReportEnJson from "./Resources/reports/trainer attendance report/trainer-attendance-report-en.json";
import * as trainerDefaulterEnJson from "./Resources/reports/trainer defaulter/trainer-defaulter-en.json";
import * as subscriptionDefaulterReportEnJson from "./Resources/reports/subscription defaulter report/subscription-defaulter-report-en.json";
import * as complainsEnJson from "./Resources/reports/complains/complains-en.json";
import * as permissionVisitorEnJson from "./Resources/setting/permission management/PermissionVisitor/permission-visitor-en.json";
import * as addpackageBuilderEnJson from "./Resources/shared/addPackage builder/addPackage-builder-en.json";
import * as registerCompanyEnJson from "./Resources/pages/register company/register-company-en.json";
import * as addServicesEnJson from "./Resources/services/add-service/add-services-en.json";
import * as trainingServiceEnJson from "./Resources/services/component/training-service-detail/training-service-en.json";
import * as servicesEnJson from "./Resources/services/services-en.json";
import * as selfServicesEnJson from "./Resources/services/component/self-servies-detail/self-services-en.json";
import * as appRightpanelEnJson from "./Resources/right-panel-en.json";
import * as trainingSessionsEnJson from "./Resources/trainer-sessions/trainer-sessions-en.json";
import * as trainerPayoutEnJson from "./Resources/trainer/trainer payout/trainer-payout-en.json";
import * as trainerDashboardEnJson from "./Resources/trainer-dashboard/trainer-dashboard-en.json";
import * as trainingSessionAttdEnJson from "./Resources/members/components/training session attd/training-session-attd-en.json";
import * as appTopbarEnJson from "./Resources/topbar/topbar-en.json";
import * as feeCollectEnJson from "./Resources/members/components/fee-collect/fee-collect-en.json";
import * as paymentEnJson from "./Resources/public/payment/payment-en.json";
import * as appLoginEnJson from "./Resources/login/login-en.json";
import * as employeesPayoutEnJson from "./Resources/setting/user management/empolyee payout/employees-payout-en.json";
import * as quotationsEnJson from "./Resources/Sales/quotations/quotations-en.json";

//===========================================================================//
//=================================> Arabic <===============================//
//=========================================================================//

import * as globalsArJson from "./Resources/global-ar.json";
import * as dashboardArJson from "./Resources/Dashboard/dashboard-ar.json";
import * as visitorsArJson from "./Resources/VisitorManagement/visitors/visitors-ar.json";
import * as activityLogsArJson from "./Resources/Activity-Logs/activity-Logs-ar.json";
import * as addAssetArJson from "./Resources/asset management/add asset/add-asset-ar.json";
import * as assetDetailArJson from "./Resources/asset management/asset detail/asset-detail-ar.json";
import * as assetsArJson from "./Resources/asset management/asset-ar.json";
import * as attendanceListArJson from "./Resources/Attendance/Attendance-List/attendance-list-ar.json";
import * as attendanceViewArJson from "./Resources/Attendance/Attendance-View/attendance-View-ar.json";
import * as bookingArJson from "./Resources/Bookings/Booking/booking-ar.json";
import * as bookingsArJson from "./Resources/Bookings/Bookings/bookings-ar.json";
import * as bookingSlotArJson from "./Resources/bookingSlots/booking-slot/booking-slot-ar.json";
import * as bookingSlotsArJson from "./Resources/bookingSlots/booking-slots/booking-slots-ar.json";
import * as addEmployeeArJson from "./Resources/employees/add Employee/add-employee-ar.json";
import * as employeesListingArJson from "./Resources/employees/employees listing/employees-listing-ar.json";
import * as addEnquiryArJson from "./Resources/enquiry/add enquiry/add-enquiry-ar.json";
import * as enquiryListingArJson from "./Resources/enquiry/enquiry listing/enquiry-listing-ar.json";
import * as feeArJson from "./Resources/Fee Management/Fee/fee-ar.json";
import * as feesArJson from "./Resources/Fee Management/Fees/fees-ar.json";
import * as paySalaryToEmployeesArJson from "./Resources/hr-pay-management/components/pay-salary-to-employees-ar.json";
import * as designationManagementArJson from "./Resources/hr-pay-management/designation-management/designation-management-ar.json";
import * as employeeSalaryManagementArJson from "./Resources/hr-pay-management/employee-salary-management/employee-salary-management-ar.json";
import * as addMembersArJson from "./Resources/members/add-members/add-members-ar.json";
import * as cameraArJson from "./Resources/members/camera/camera-ar.json";
import * as addFeeArJson from "./Resources/members/components/add-fee/add-fee-ar.json";
import * as addFeeMemberArJson from "./Resources/members/components/add-fee-member/add-fee-member-ar.json";
import * as bookTrainerArJson from "./Resources/members/components/book-trainer/book-trainer-ar.json";
import * as sessionAttendanceReportArJson from "./Resources/session-attendance-report/session-attendance-report-ar.json";
import * as sessionSalesReportArJson from "./Resources/session-sales-report/session-sales-report-ar.json";
import * as sessionAttendanceArJson from "./Resources/session-attendance/session-attendance-ar.json";
import * as appPasswordArJson from "./Resources/members/components/aap-password/app-password-ar.json";
import * as exportDataArJson from "./Resources/members/components/export-data/export-data-ar.json";
import * as feesInvoiceArJson from "./Resources/members/components/fees-invoice/fees-invoice-ar.json";
import * as emailConfirmationModelArJson from "./Resources/members/email-confirmation-model/email-confirmation-model-ar.json";
import * as inactiveMembersArJson from "./Resources/members/inactive-members/inactive-members-ar.json";
import * as membersArJson from "./Resources/members/members/members-ar.json";
import * as packageBuilderArJson from "./Resources/packageBuilder/packageBuilder/package-builder-ar.json";
import * as packageBuildersArJson from "./Resources/packageBuilder/packageBuilders/package-builders-ar.json";
import * as pettyCashArJson from "./Resources/petty-cash/petty-cash-ar.json";
import * as addProductArJson from "./Resources/products/add products/add-product-ar.json";
import * as productCategoriesArJson from "./Resources/products/product categories/product-categories-ar.json";
import * as productCategoryArJson from "./Resources/products/product category/product-category-ar.json";
import * as productsListingArJson from "./Resources/products/product listing/product-listing-ar.json";
import * as updateStockCountArJson from "./Resources/products/update stock count/update-stock-count-ar.json";
import * as contactUsArJson from "./Resources/public/contact us/contact-us-ar.json";
import * as loginLogsArJson from "./Resources/public/login logs/login-logs-ar.json";
import * as activeMemberReportArJson from "./Resources/reports/active member report/active-member-report-ar.json";
import * as attendenceReportArJson from "./Resources/reports/attendance report/attendance-report-ar.json";
import * as checkInReportArJson from "./Resources/reports/check in report/check-in-report-ar.json";
import * as dailyClosingReportArJson from "./Resources/reports/daily closing report/daily-closing-report-ar.json";
import * as defaulterReportArJson from "./Resources/reports/defaulter report/defaulter-report-ar.json";
import * as newMemberReportArJson from "./Resources/reports/new member report/new-member-report-ar.json";
import * as memberReportArJson from "./Resources/reports/member report/member-report-ar.json";
import * as pOSSalesReportArJson from "./Resources/reports/pos sales report/pos-sales-report-ar.json";
import * as purchaseHistoryReportsArJson from "./Resources/reports/purchase history report/purchase-history-report-ar.json";
import * as requestManagementReportsArJson from "./Resources/reports/request management report/request-management-report-ar.json";
import * as salesReportsArJson from "./Resources/reports/sales report/sales-report-ar.json";
import * as trainerSalesReportArJson from "./Resources/reports/trainer sales report/trainer-sales-report-ar.json";
import * as trainerClientsReportArJson from "./Resources/reports/trainer clients report/trainer-clients-report-ar.json";
import * as trainerSessionReportArJson from "./Resources/reports/trainer session report/trainer-session-report-ar.json";
import * as trainingAttendenceReportArJson from "./Resources/reports/training attendence report/training-attendence-report-ar.json";
import * as upcomingBirthdaysReportArJson from "./Resources/reports/upcoming birthdays/upcoming-birthdays-report-ar.json";
import * as upcomingDuesReportArJson from "./Resources/reports/upcoming dues report/upcoming-dues-report-ar.json";
import * as usersAttendanceReportArJson from "./Resources/reports/users attendance report/users-attendance-report-ar.json";
import * as reportsArJson from "./Resources/reports/billing report/billing-report-ar.json";
import * as feeSubmissionRequestDetailArJson from "./Resources/request management/components/fee submission request detail/fee-submission-request-detail-ar.json";
import * as memberRequestDetailArJson from "./Resources/request management/components/member request detail/member-request-detail-ar.json";
import * as requestsManagementArJson from "./Resources/request management/request management/request-management-ar.json";
import * as pointOfSaleArJson from "./Resources/Sales/point of sale/point-of-sale-ar.json";
import * as saleOrdersArJson from "./Resources/Sales/sale orders/sale-orders-ar.json";
import * as branchArJson from "./Resources/setting/branch management/branch/branch-ar.json";
import * as branchesArJson from "./Resources/setting/branch management/branches/branches-ar.json";
import * as registerBranchFromCompanyArJson from "./Resources/setting/branch management/register-branch-from-company/register-branch-from-company-ar.json";
import * as companiesArJson from "./Resources/setting/company management/companies/companies-ar.json";
import * as companyArJson from "./Resources/setting/company management/company/company-ar.json";
import * as userPasswordArJson from "./Resources/setting/user password/user-password-ar.json";
import * as permissionArJson from "./Resources/setting/permission management/Permission/permission-ar.json";
import * as permissionsArJson from "./Resources/setting/permission management/Permissions/permissions-ar.json";
import * as roleArJson from "./Resources/setting/role management/role/role-ar.json";
import * as rolesArJson from "./Resources/setting/role management/roles/roles-ar.json";
import * as userArJson from "./Resources/setting/user management/user/user-ar.json";
import * as trainerPackagesArJson from "./Resources/setting/user management/trainer-packages/trainer-packages-ar.json";
import * as trainerScheduleArJson from "./Resources/setting/user management/trainer-schedule/trainer-schedule-ar.json";
import * as trainerModuleSettingsArJson from "./Resources/setting/branch management/trainer-module-settings/trainer-module-settings-ar.json";
import * as usersArJson from "./Resources/setting/user management/users/users-ar.json";
import * as receiptPrintArJson from "./Resources/shared/receipt/receipt print/receipt-print-ar.json";
import * as singleReceiptPrintArJson from "./Resources/shared/receipt/single receipt print/single-receipt-print-ar.json";
import * as singleReceiptEmailArJson from "./Resources/shared/receipt/single receipt email/single-receipt-email-ar.json";
import * as signupArJson from "./Resources/shared/signup/signup-ar.json";
import * as addSingleSignupArJson from "./Resources/shared/signup/add single signup/add-single-signup-ar.json";
import * as addMultipleSignupArJson from "./Resources/shared/signup/add multiple signup/add-multiple-signup-ar.json";
import * as inActiveMemberReportArJson from "./Resources/reports/inactive member report/inactive-member-report-ar.json";
import * as enquiryManagementReportArJson from "./Resources/reports/enquiry management report/enquiry-management-report-ar.json";
import * as addSupplierArJson from "./Resources/supplier/add supplier/add-supplier-ar.json";
import * as purchaseOrderArJson from "./Resources/supplier/purchase order/purchase-order-ar.json";
import * as purchaseOrdersArJson from "./Resources/supplier/purchase orders/puchase-orders-ar.json";
import * as supplierListingArJson from "./Resources/supplier/supplier listing/supplier-listing-ar.json";
import * as membersTrainingAttendanceArJson from "./Resources/trainer/members training attendance/members-training-attendance-ar.json";
import * as membersTrainingAttendanceViewArJson from "./Resources/trainer/members training attendance view/members-training-attendance-view-ar.json";
import * as addVisitorArJson from "./Resources/VisitorManagement/addVisitor/add-visitor-ar.json";
import * as visitorDialogueArJson from "./Resources/VisitorManagement/Independent Visitor/independent-visitor-ar.json";
import * as visitorRequestDetailArJson from "./Resources/request management/components/visitor request detail/visitor-request-detail-ar.json";
import * as freezeRequestDetailArJson from "./Resources/request management/components/freeze request detail/freeze-request-detail-ar.json";
import * as visitorReportArJson from "./Resources/reports/visitor report/visitor-report-ar.json";
import * as globalArJson from "./Resources/global/global-ar.json";
import * as closingReportArJson from "./Resources/reports/closing report/closing-report-ar.json";
import * as userInformationArJson from "./Resources/pages/user information/user-information-ar.json";
import * as notificationArJson from "./Resources/notification center/notification/notification-ar.json";
import * as notificationsArJson from "./Resources/notification center/notifications/notifications-ar.json";
import * as addTrainerArJson from "./Resources/trainer/add trainer/add-trainer-ar.json";
import * as trainersArJson from "./Resources/trainer/trainers/trainers-ar.json";
import * as appFormFieldsArJson from "./Resources/global/app form fields/app-form-fields-ar.json";
import * as trainerAttendanceReportArJson from "./Resources/reports/trainer attendance report/trainer-attendance-report-ar.json";
import * as trainerDefaulterArJson from "./Resources/reports/trainer defaulter/trainer-defaulter-ar.json";
import * as subscriptionDefaulterReportArJson from "./Resources/reports/subscription defaulter report/subscription-defaulter-report-ar.json";
import * as complainsArJson from "./Resources/reports/complains/complains-ar.json";
import * as permissionVisitorArJson from "./Resources/setting/permission management/PermissionVisitor/permission-visitor-ar.json";
import * as addpackageBuilderArJson from "./Resources/shared/addPackage builder/addPackage-builder-ar.json";
import * as registerCompanyArJson from "./Resources/pages/register company/register-company-ar.json";
import * as addServicesArJson from "./Resources/services/add-service/add-services-ar.json";
import * as trainingServiceArJson from "./Resources/services/component/training-service-detail/training-service-ar.json";
import * as servicesArJson from "./Resources/services/services-ar.json";
import * as selfServicesArJson from "./Resources/services/component/self-servies-detail/self-services-ar.json";

import * as appRightpanelArJson from "./Resources/right-panel-ar.json";
import * as trainingSessionsArJson from "./Resources/trainer-sessions/trainer-sessions-ar.json";
import * as trainerPayoutArJson from "./Resources/trainer/trainer payout/trainer-payout-ar.json";
import * as trainerDashboardArJson from "./Resources/trainer-dashboard/trainer-dashboard-ar.json";
import * as trainingSessionAttdArJson from "./Resources/members/components/training session attd/training-session-attd-ar.json";
import * as appTopbarArJson from "./Resources/topbar/topbar-ar.json";
import * as feeCollectArJson from "./Resources/members/components/fee-collect/fee-collect-ar.json";
import * as paymentArJson from "./Resources/public/payment/payment-ar.json";
import * as appLoginArJson from "./Resources/login/login-ar.json";
import * as employeesPayoutArJson from  "./Resources/setting/user management/empolyee payout/employees-payout-ar.json";
import * as quotationsArJson from "./Resources/Sales/quotations/quotations-ar.json";

//===========================================================================//
//=================================> Urdu <=================================//
//=========================================================================//

import * as globalsUrJson from "./Resources/global-ur.json";
import * as dashboardUrJson from "./Resources/Dashboard/dashboard-ur.json";
import * as visitorsUrJson from "./Resources/VisitorManagement/visitors/visitors-ur.json";
import * as activityLogsUrJson from "./Resources/Activity-Logs/activity-logs-ur.json";
import * as addAssetUrJson from "./Resources/asset management/add asset/add-asset-ur.json";
import * as assetDetailUrJson from "./Resources/asset management/asset detail/asset-detail-ur.json";
import * as assetsUrJson from "./Resources/asset management/asset-ur.json";
import * as attendanceListUrJson from "./Resources/Attendance/Attendance-List/attendance-list-ur.json";
import * as attendanceViewUrJson from "./Resources/Attendance/Attendance-View/attendance-View-ur.json";
import * as bookingUrJson from "./Resources/Bookings/Booking/booking-ur.json";
import * as bookingsUrJson from "./Resources/Bookings/Bookings/bookings-ur.json";
import * as bookingSlotUrJson from "./Resources/bookingSlots/booking-slot/booking-slot-ur.json";
import * as bookingSlotsUrJson from "./Resources/bookingSlots/booking-slots/booking-slots-ur.json";
import * as addEmployeeUrJson from "./Resources/employees/add Employee/add-employee-ur.json";
import * as employeesListingUrJson from "./Resources/employees/employees listing/employees-listing-ur.json";
import * as addEnquiryUrJson from "./Resources/enquiry/add enquiry/add-enquiry-ur.json";
import * as enquiryListingUrJson from "./Resources/enquiry/enquiry listing/enquiry-listing-ur.json";
import * as feeUrJson from "./Resources/Fee Management/Fee/fee-ur.json";
import * as feesUrJson from "./Resources/Fee Management/Fees/fees-ur.json";
import * as paySalaryToEmployeesUrJson from "./Resources/hr-pay-management/components/pay-salary-to-employees-ur.json";
import * as designationManagementUrJson from "./Resources/hr-pay-management/designation-management/designation-management-ur.json";
import * as employeeSalaryManagementUrJson from "./Resources/hr-pay-management/employee-salary-management/employee-salary-management-ur.json";
import * as addMembersUrJson from "./Resources/members/add-members/add-members-ur.json";
import * as cameraUrJson from "./Resources/members/camera/camera-ur.json";
import * as addFeeUrJson from "./Resources/members/components/add-fee/add-fee-ur.json";
import * as addFeeMemberUrJson from "./Resources/members/components/add-fee-member/add-fee-member-ur.json";
import * as bookTrainerUrJson from "./Resources/members/components/book-trainer/book-trainer-ur.json";
import * as sessionAttendanceReportUrJson from "./Resources/session-attendance-report/session-attendance-report-ur.json";
import * as sessionSalesReportUrJson from "./Resources/session-sales-report/session-sales-report-ur.json";
import * as sessionAttendanceUrJson from "./Resources/session-attendance/session-attendance-ur.json";
import * as appPasswordUrJson from "./Resources/members/components/aap-password/app-password-ur.json";
import * as exportDataUrJson from "./Resources/members/components/export-data/export-data-ur.json";
import * as feesInvoiceUrJson from "./Resources/members/components/fees-invoice/fees-invoice-ur.json";
import * as emailConfirmationModelUrJson from "./Resources/members/email-confirmation-model/email-confirmation-model-ur.json";
import * as inactiveMembersUrJson from "./Resources/members/inactive-members/inactive-members-ur.json";
import * as membersUrJson from "./Resources/members/members/members-ur.json";
import * as packageBuilderUrJson from "./Resources/packageBuilder/packageBuilder/package-builder-ur.json";
import * as packageBuildersUrJson from "./Resources/packageBuilder/packageBuilders/package-builders-ur.json";
import * as pettyCashUrJson from "./Resources/petty-cash/petty-cash-ur.json";
import * as addProductUrJson from "./Resources/products/add products/add-product-ur.json";
import * as productCategoriesUrJson from "./Resources/products/product categories/product-categories-ur.json";
import * as productCategoryUrJson from "./Resources/products/product category/product-category-ur.json";
import * as productsListingUrJson from "./Resources/products/product listing/product-listing-ur.json";
import * as updateStockCountUrJson from "./Resources/products/update stock count/update-stock-count-ur.json";
import * as contactUsUrJson from "./Resources/public/contact us/contact-us-ur.json";
import * as loginLogsUrJson from "./Resources/public/login logs/login-logs-ur.json";
import * as activeMemberReportUrJson from "./Resources/reports/active member report/active-member-report-ur.json";
import * as attendenceReportUrJson from "./Resources/reports/attendance report/attendance-report-ur.json";
import * as checkInReportUrJson from "./Resources/reports/check in report/check-in-report-ur.json";
import * as dailyClosingReportUrJson from "./Resources/reports/daily closing report/daily-closing-report-ur.json";
import * as defaulterReportUrJson from "./Resources/reports/defaulter report/defaulter-report-ur.json";
import * as newMemberReportUrJson from "./Resources/reports/new member report/new-member-report-ur.json";
import * as memberReportUrJson from "./Resources/reports/member report/member-report-ur.json";
import * as pOSSalesReportUrJson from "./Resources/reports/pos sales report/pos-sales-report-ur.json";
import * as purchaseHistoryReportsUrJson from "./Resources/reports/purchase history report/purchase-history-report-ur.json";
import * as requestManagementReportsUrJson from "./Resources/reports/request management report/request-management-report-ur.json";
import * as salesReportsUrJson from "./Resources/reports/sales report/sales-report-ur.json";
import * as trainerSalesReportUrJson from "./Resources/reports/trainer sales report/trainer-sales-report-ur.json";
import * as trainerClientsReportUrJson from "./Resources/reports/trainer clients report/trainer-clients-report-ur.json";
import * as trainerSessionReportUrJson from "./Resources/reports/trainer session report/trainer-session-report-ur.json";
import * as trainingAttendenceReportUrJson from "./Resources/reports/training attendence report/training-attendence-report-ur.json";
import * as upcomingBirthdaysReportUrJson from "./Resources/reports/upcoming birthdays/upcoming-birthdays-report-ur.json";
import * as upcomingDuesReportUrJson from "./Resources/reports/upcoming dues report/upcoming-dues-report-ur.json";
import * as usersAttendanceReportUrJson from "./Resources/reports/users attendance report/users-attendance-report-ur.json";
import * as reportsUrJson from "./Resources/reports/billing report/billing-report-ur.json";
import * as feeSubmissionRequestDetailUrJson from "./Resources/request management/components/fee submission request detail/fee-submission-request-detail-ur.json";
import * as memberRequestDetailUrJson from "./Resources/request management/components/member request detail/member-request-detail-ur.json";
import * as requestsManagementUrJson from "./Resources/request management/request management/request-management-ur.json";
import * as pointOfSaleUrJson from "./Resources/Sales/point of sale/point-of-sale-ur.json";
import * as saleOrdersUrJson from "./Resources/Sales/sale orders/sale-orders-ur.json";
import * as branchUrJson from "./Resources/setting/branch management/branch/branch-ur.json";
import * as branchesUrJson from "./Resources/setting/branch management/branches/branches-ur.json";
import * as registerBranchFromCompanyUrJson from "./Resources/setting/branch management/register-branch-from-company/register-branch-from-company-ur.json";
import * as companiesUrJson from "./Resources/setting/company management/companies/companies-ur.json";
import * as companyUrJson from "./Resources/setting/company management/company/company-ur.json";
import * as userPasswordUrJson from "./Resources/setting/user password/user-password-ur.json";
import * as permissionUrJson from "./Resources/setting/permission management/Permission/permission-ur.json";
import * as permissionsUrJson from "./Resources/setting/permission management/Permissions/permissions-ur.json";
import * as roleUrJson from "./Resources/setting/role management/role/role-ur.json";
import * as rolesUrJson from "./Resources/setting/role management/roles/roles-ur.json";
import * as userUrJson from "./Resources/setting/user management/user/user-ur.json";
import * as trainerPackagesUrJson from "./Resources/setting/user management/trainer-packages/trainer-packages-ur.json";
import * as trainerScheduleUrJson from "./Resources/setting/user management/trainer-schedule/trainer-schedule-ur.json";
import * as trainerModuleSettingsUrJson from "./Resources/setting/branch management/trainer-module-settings/trainer-module-settings-ur.json";
import * as usersUrJson from "./Resources/setting/user management/users/users-ur.json";
import * as receiptPrintUrJson from "./Resources/shared/receipt/receipt print/receipt-print-ur.json";
import * as singleReceiptPrintUrJson from "./Resources/shared/receipt/single receipt print/single-receipt-print-ur.json";
import * as singleReceiptEmailUrJson from "./Resources/shared/receipt/single receipt email/single-receipt-email-ur.json";
import * as signupUrJson from "./Resources/shared/signup/signup-ur.json";
import * as addSingleSignupUrJson from "./Resources/shared/signup/add single signup/add-single-signup-ur.json";
import * as addMultipleSignupUrJson from "./Resources/shared/signup/add multiple signup/add-multiple-signup-ur.json";
import * as inActiveMemberReportUrJson from "./Resources/reports/inactive member report/inactive-member-report-ur.json";
import * as enquiryManagementReportUrJson from "./Resources/reports/enquiry management report/enquiry-management-report-ur.json";
import * as addSupplierUrJson from "./Resources/supplier/add supplier/add-supplier-ur.json";
import * as purchaseOrderUrJson from "./Resources/supplier/purchase order/purchase-order-ur.json";
import * as purchaseOrdersUrJson from "./Resources/supplier/purchase orders/puchase-orders-ur.json";
import * as supplierListingUrJson from "./Resources/supplier/supplier listing/supplier-listing-ur.json";
import * as membersTrainingAttendanceUrJson from "./Resources/trainer/members training attendance/members-training-attendance-Ur.json";
import * as membersTrainingAttendanceViewUrJson from "./Resources/trainer/members training attendance view/members-training-attendance-view-ur.json";
import * as addVisitorUrJson from "./Resources/VisitorManagement/addVisitor/add-visitor-ur.json";
import * as visitorDialogueUrJson from "./Resources/VisitorManagement/Independent Visitor/independent-visitor-ur.json";
import * as visitorRequestDetailUrJson from "./Resources/request management/components/visitor request detail/visitor-request-detail-ur.json";
import * as freezeRequestDetailUrJson from "./Resources/request management/components/freeze request detail/freeze-request-detail-ur.json";
import * as visitorReportUrJson from "./Resources/reports/visitor report/visitor-report-ur.json";
import * as globalUrJson from "./Resources/global/global-ur.json";
import * as closingReportUrJson from "./Resources/reports/closing report/closing-report-ur.json";
import * as userInformationUrJson from "./Resources/pages/user information/user-information-ur.json";
import * as notificationUrJson from "./Resources/notification center/notification/notification-ur.json";
import * as notificationsUrJson from "./Resources/notification center/notifications/notifications-ur.json";
import * as addTrainerUrJson from "./Resources/trainer/add trainer/add-trainer-ur.json";
import * as trainersUrJson from "./Resources/trainer/trainers/trainers-ur.json";
import * as appFormFieldsUrJson from "./Resources/global/app form fields/app-form-fields-ur.json";
import * as trainerAttendanceReportUrJson from "./Resources/reports/trainer attendance report/trainer-attendance-report-ur.json";
import * as trainerDefaulterUrJson from "./Resources/reports/trainer defaulter/trainer-defaulter-ur.json";
import * as subscriptionDefaulterReportUrJson from "./Resources/reports/subscription defaulter report/subscription-defaulter-report-ur.json";
import * as complainsUrJson from "./Resources/reports/complains/complains-ur.json";
import * as permissionVisitorUrJson from "./Resources/setting/permission management/PermissionVisitor/permission-visitor-ur.json";
import * as addpackageBuilderUrJson from "./Resources/shared/addPackage builder/addPackage-builder-ur.json";
import * as registerCompanyUrJson from "./Resources/pages/register company/register-company-ur.json";
import * as addServicesUrJson from "./Resources/services/add-service/add-services-ur.json";
import * as trainingServiceUrJson from "./Resources/services/component/training-service-detail/training-service-ur.json";
import * as servicesUrJson from "./Resources/services/services-ur.json";
import * as selfServicesUrJson from "./Resources/services/component/self-servies-detail/self-services-ur.json";

import * as appRightpanelUrJson from "./Resources/right-panel-ur.json";
import * as trainingSessionsUrJson from "./Resources/trainer-sessions/trainer-sessions-ur.json";
import * as trainerPayoutUrJson from "./Resources/trainer/trainer payout/trainer-payout-ur.json";
import * as trainerDashboardUrJson from "./Resources/trainer-dashboard/trainer-dashboard-ur.json";
import * as trainingSessionAttdUrJson from "./Resources/members/components/training session attd/training-session-attd-ur.json";
import * as appTopbarUrJson from "./Resources/topbar/topbar-ur.json";
import * as feeCollectUrJson from "./Resources/members/components/fee-collect/fee-collect-ur.json";
import * as paymentUrJson from "./Resources/public/payment/payment-ur .json";
import * as appLoginUrJson from "./Resources/login/login-ur.json";
import * as employeesPayoutUrJson from  "./Resources/setting/user management/empolyee payout/employees-payout-ur.json";
import * as quotationsUrJson from "./Resources/Sales/quotations/quotations-ur.json";

//===========================================================================//
//=================================> pashto <=================================//
//=========================================================================//
import * as globalsPsJson from "./Resources/global-ps.json";
import * as dashboardPsJson from "./Resources/Dashboard/dashboard-ps.json";
import * as visitorsPsJson from "./Resources/VisitorManagement/visitors/visitors-ps.json";
import * as activityLogsPsJson from "./Resources/Activity-Logs/activity-Logs-ps.json";
import * as addAssetPsJson from "./Resources/asset management/add asset/add-asset-ps.json";
import * as assetDetailPsJson from "./Resources/asset management/asset detail/asset-detail-ps.json";
import * as assetsPsJson from "./Resources/asset management/asset-ps.json";
import * as attendanceListPsJson from "./Resources/Attendance/Attendance-List/attendance-list-ps.json";
import * as attendanceViewPsJson from "./Resources/Attendance/Attendance-View/attendance-View-ps.json";
import * as bookingPsJson from "./Resources/Bookings/Booking/booking-ps.json";
import * as bookingsPsJson from "./Resources/Bookings/Bookings/bookings-ps.json";
import * as bookingSlotPsJson from "./Resources/bookingSlots/booking-slot/booking-slot-ps.json";
import * as bookingSlotsPsJson from "./Resources/bookingSlots/booking-slots/booking-slots-ps.json";
import * as addEmployeePsJson from "./Resources/employees/add Employee/add-employee-ps.json";
import * as employeesListingPsJson from "./Resources/employees/employees listing/employees-listing-ps.json";
import * as addEnquiryPsJson from "./Resources/enquiry/add enquiry/add-enquiry-ps.json";
import * as enquiryListingPsJson from "./Resources/enquiry/enquiry listing/enquiry-listing-ps.json";
import * as feePsJson from "./Resources/Fee Management/Fee/fee-ps.json";
import * as feesPsJson from "./Resources/Fee Management/Fees/fees-ps.json";
import * as paySalaryToEmployeesPsJson from "./Resources/hr-pay-management/components/pay-salary-to-employees-ps.json";
import * as designationManagementPsJson from "./Resources/hr-pay-management/designation-management/designation-management-ps.json";
import * as employeeSalaryManagementPsJson from "./Resources/hr-pay-management/employee-salary-management/employee-salary-management-ps.json";
import * as addMembersPsJson from "./Resources/members/add-members/add-members-ps.json";
import * as cameraPsJson from "./Resources/members/camera/camera-ps.json";
import * as addFeePsJson from "./Resources/members/components/add-fee/add-fee-ps.json";
import * as addFeeMemberPsJson from "./Resources/members/components/add-fee-member/add-fee-member-ps.json";
import * as bookTrainerPsJson from "./Resources/members/components/book-trainer/book-trainer-ps.json";
import * as sessionAttendanceReportPsJson from "./Resources/session-attendance-report/session-attendance-report-ps.json";
import * as sessionSalesReportPsJson from "./Resources/session-sales-report/session-sales-report-ps.json";
import * as sessionAttendancePsJson from "./Resources/session-attendance/session-attendance-ps.json";
import * as appPasswordPsJson from "./Resources/members/components/aap-password/app-password-ps.json";
import * as exportDataPsJson from "./Resources/members/components/export-data/export-data-ps.json";
import * as feesInvoicePsJson from "./Resources/members/components/fees-invoice/fees-invoice-ps.json";
import * as emailConfirmationModelPsJson from "./Resources/members/email-confirmation-model/email-confirmation-model-ps.json";
import * as inactiveMembersPsJson from "./Resources/members/inactive-members/inactive-members-ps.json";
import * as membersPsJson from "./Resources/members/members/members-ps.json";
import * as packageBuilderPsJson from "./Resources/packageBuilder/packageBuilder/package-builder-ps.json";
import * as packageBuildersPsJson from "./Resources/packageBuilder/packageBuilders/package-builders-ps.json";
import * as pettyCashPsJson from "./Resources/petty-cash/petty-cash-ps.json";
import * as addProductPsJson from "./Resources/products/add products/add-product-ps.json";
import * as productCategoriesPsJson from "./Resources/products/product categories/product-categories-ps.json";
import * as productCategoryPsJson from "./Resources/products/product category/product-category-ps.json";
import * as productsListingPsJson from "./Resources/products/product listing/product-listing-ps.json";
import * as updateStockCountPsJson from "./Resources/products/update stock count/update-stock-count-ps.json";
import * as contactUsPsJson from "./Resources/public/contact us/contact-us-ps.json";
import * as loginLogsPsJson from "./Resources/public/login logs/login-logs-ps.json";
import * as activeMemberReportPsJson from "./Resources/reports/active member report/active-member-report-ps.json";
import * as attendenceReportPsJson from "./Resources/reports/attendance report/attendance-report-ps.json";
import * as checkInReportPsJson from "./Resources/reports/check in report/check-in-report-ps.json";
import * as dailyClosingReportPsJson from "./Resources/reports/daily closing report/daily-closing-report-ps.json";
import * as defaulterReportPsJson from "./Resources/reports/defaulter report/defaulter-report-ps.json";
import * as newMemberReportPsJson from "./Resources/reports/new member report/new-member-report-ps.json";
import * as memberReportPsJson from "./Resources/reports/member report/member-report-ps.json";
import * as pOSSalesReportPsJson from "./Resources/reports/pos sales report/pos-sales-report-ps.json";
import * as purchaseHistoryReportsPsJson from "./Resources/reports/purchase history report/purchase-history-report-ps.json";
import * as requestManagementReportsPsJson from "./Resources/reports/request management report/request-management-report-ps.json";
import * as salesReportsPsJson from "./Resources/reports/sales report/sales-report-ps.json";
import * as trainerSalesReportPsJson from "./Resources/reports/trainer sales report/trainer-sales-report-ps.json";
import * as trainerClientsReportPsJson from "./Resources/reports/trainer clients report/trainer-clients-report-ps.json";
import * as trainerSessionReportPsJson from "./Resources/reports/trainer session report/trainer-session-report-ps.json";
import * as trainingAttendenceReportPsJson from "./Resources/reports/training attendence report/training-attendence-report-ps.json";
import * as upcomingBirthdaysReportPsJson from "./Resources/reports/upcoming birthdays/upcoming-birthdays-report-ps.json";
import * as upcomingDuesReportPsJson from "./Resources/reports/upcoming dues report/upcoming-dues-report-ps.json";
import * as usersAttendanceReportPsJson from "./Resources/reports/users attendance report/users-attendance-report-ps.json";
import * as reportsPsJson from "./Resources/reports/billing report/billing-report-ps.json";
import * as feeSubmissionRequestDetailPsJson from "./Resources/request management/components/fee submission request detail/fee-submission-request-detail-ps.json";
import * as memberRequestDetailPsJson from "./Resources/request management/components/member request detail/member-request-detail-ps.json";
import * as requestsManagementPsJson from "./Resources/request management/request management/request-management-ps.json";
import * as pointOfSalePsJson from "./Resources/Sales/point of sale/point-of-sale-ps.json";
import * as saleOrdersPsJson from "./Resources/Sales/sale orders/sale-orders-ps.json";
import * as branchPsJson from "./Resources/setting/branch management/branch/branch-ps.json";
import * as branchesPsJson from "./Resources/setting/branch management/branches/branches-ps.json";
import * as registerBranchFromCompanyPsJson from "./Resources/setting/branch management/register-branch-from-company/register-branch-from-company-ps.json";
import * as companiesPsJson from "./Resources/setting/company management/companies/companies-ps.json";
import * as companyPsJson from "./Resources/setting/company management/company/company-ps.json";
import * as userPasswordPsJson from "./Resources/setting/user password/user-password-ps.json";
import * as permissionPsJson from "./Resources/setting/permission management/Permission/permission-ps.json";
import * as permissionsPsJson from "./Resources/setting/permission management/Permissions/permissions-ps.json";
import * as rolePsJson from "./Resources/setting/role management/role/role-ps.json";
import * as rolesPsJson from "./Resources/setting/role management/roles/roles-ps.json";
import * as userPsJson from "./Resources/setting/user management/user/user-ps.json";
import * as trainerPackagesPsJson from "./Resources/setting/user management/trainer-packages/trainer-packages-ps.json";
import * as trainerSchedulePsJson from "./Resources/setting/user management/trainer-schedule/trainer-schedule-ps.json";
import * as trainerModuleSettingsPsJson from "./Resources/setting/branch management/trainer-module-settings/trainer-module-settings-ps.json";
import * as usersPsJson from "./Resources/setting/user management/users/users-ps.json";
import * as receiptPrintPsJson from "./Resources/shared/receipt/receipt print/receipt-print-ps.json";
import * as singleReceiptPrintPsJson from "./Resources/shared/receipt/single receipt print/single-receipt-print-ps.json";
import * as singleReceiptEmailPsJson from "./Resources/shared/receipt/single receipt email/single-receipt-email-ps.json";
import * as signupPsJson from "./Resources/shared/signup/signup-ps.json";
import * as addSingleSignupPsJson from "./Resources/shared/signup/add single signup/add-single-signup-ps.json";
import * as addMultipleSignupPsJson from "./Resources/shared/signup/add multiple signup/add-multiple-signup-ps.json";
import * as inActiveMemberReportPsJson from "./Resources/reports/inactive member report/inactive-member-report-ps.json";
import * as enquiryManagementReportPsJson from "./Resources/reports/enquiry management report/enquiry-management-report-ps.json";
import * as addSupplierPsJson from "./Resources/supplier/add supplier/add-supplier-ps.json";
import * as purchaseOrderPsJson from "./Resources/supplier/purchase order/purchase-order-ps.json";
import * as purchaseOrdersPsJson from "./Resources/supplier/purchase orders/purchase-orders-ps.json";
import * as supplierListingPsJson from "./Resources/supplier/supplier listing/supplier-listing-ps.json";
import * as membersTrainingAttendancePsJson from "./Resources/trainer/members training attendance/members-training-attendance-ps.json";
import * as membersTrainingAttendanceViewPsJson from "./Resources/trainer/members training attendance view/members-training-attendance-view-ps.json";
import * as addVisitorPsJson from "./Resources/VisitorManagement/addVisitor/add-visitor-ps.json";
import * as visitorDialoguePsJson from "./Resources/VisitorManagement/Independent Visitor/independent-visitor-ps.json";
import * as visitorRequestDetailPsJson from "./Resources/request management/components/visitor request detail/visitor-request-detail-ps.json";
import * as freezeRequestDetailPsJson from "./Resources/request management/components/freeze request detail/freeze-request-detail-ps.json";
import * as visitorReportPsJson from "./Resources/reports/visitor report/visitor-report-ps.json";
import * as globalPsJson from "./Resources/global/global-ps.json";
import * as closingReportPsJson from "./Resources/reports/closing report/closing-report-ps.json";
import * as userInformationPsJson from "./Resources/pages/user information/user-information-ps.json";
import * as notificationPsJson from "./Resources/notification center/notification/notification-ps.json";
import * as notificationsPsJson from "./Resources/notification center/notifications/notifications-ps.json";
import * as addTrainerPsJson from "./Resources/trainer/add trainer/add-trainer-ps.json";
import * as trainersPsJson from "./Resources/trainer/trainers/trainers-ps.json";
import * as appFormFieldsPsJson from "./Resources/global/app form fields/app-form-fields-ps.json";
import * as trainerAttendanceReportPsJson from "./Resources/reports/trainer attendance report/trainer-attendance-report-ps.json";
import * as trainerDefaulterPsJson from "./Resources/reports/trainer defaulter/trainer-defaulter-ps.json";
import * as subscriptionDefaulterReportPsJson from "./Resources/reports/subscription defaulter report/subscription-defaulter-report-ps.json";
import * as complainsPsJson from "./Resources/reports/complains/complains-ps.json";
import * as permissionVisitorPsJson from "./Resources/setting/permission management/PermissionVisitor/permission-visitor-ps.json";
import * as addpackageBuilderPsJson from "./Resources/shared/addPackage builder/addPackage-builder-ps.json";
import * as registerCompanyPsJson from "./Resources/pages/register company/register-company-ps.json";
import * as addServicesPsJson from "./Resources/services/add-service/add-services-ps.json";
import * as trainingServicePsJson from "./Resources/services/component/training-service-detail/training-service-ps.json";
import * as servicesPsJson from "./Resources/services/services-ps.json";
import * as selfServicesPsJson from "./Resources/services/component/self-servies-detail/self-services-ps.json";

import * as appRightpanelPsJson from "./Resources/right-panel-ps.json";
import * as trainingSessionsPsJson from "./Resources/trainer-sessions/trainer-sessions-ps.json";
import * as trainerPayoutPsJson from "./Resources/trainer/trainer payout/trainer-payout-ps.json";
import * as trainerDashboardPsJson from "./Resources/trainer-dashboard/trainer-dashboard-ps.json";
import * as trainingSessionAttdPsJson from "./Resources/members/components/training session attd/training-session-attd-ps.json";
import * as appTopbarPsJson from "./Resources/topbar/topbar-ps.json";
import * as feeCollectPsJson from "./Resources/members/components/fee-collect/fee-collect-ps.json";
import * as paymentPsJson from "./Resources/public/payment/payment-ps.json";
import * as appLoginPsJson from "./Resources/login/login-ps.json";
import * as employeesPayoutPsJson from  "./Resources/setting/user management/empolyee payout/employees-payout-ps.json";
import * as quotationsPsJson from "./Resources/Sales/quotations/quotations-ps.json";
export class LanguageService {
    lang = "en";

    visitorsLangEnJson: any = { ...visitorsEnJson, ...globalsEnJson };
    visitorsLangArJson: any = { ...visitorsArJson, ...globalsArJson };
    visitorsLangUrJson: any = { ...visitorsUrJson, ...globalsUrJson };
    visitorsLangPsJson: any = { ...visitorsPsJson, ...globalsPsJson };

    dashboardLangEnJson: any = { ...dashboardEnJson, ...globalsEnJson };
    dashboardLangArJson: any = { ...dashboardArJson, ...globalsArJson };
    dashboardLangUrJson: any = { ...dashboardUrJson, ...globalsUrJson };
    dashboardLangPsJson: any = { ...dashboardPsJson, ...globalsPsJson };

    activityLogsLangEnJson: any = { ...activityLogsEnJson, ...globalsEnJson };//////////////////////////
    activityLogsLangArJson: any = { ...activityLogsArJson, ...globalsArJson };//////////////////////////////
    activityLogsLangUrJson: any = { ...activityLogsUrJson, ...globalsUrJson };////////////////////////
    activityLogsLangPsJson: any = { ...activityLogsPsJson, ...globalsPsJson };//////////////////////////////////////////

    addAssetLangEnJson: any = { ...addAssetEnJson, ...globalsEnJson };
    addAssetLangArJson: any = { ...addAssetArJson, ...globalsArJson };
    addAssetLangUrJson: any = { ...addAssetUrJson, ...globalsUrJson };
    addAssetLangPsJson: any = { ...addAssetPsJson, ...globalsPsJson };

    assetDetailLangEnJson: any = { ...assetDetailEnJson, ...globalsEnJson };
    assetDetailLangArJson: any = { ...assetDetailArJson, ...globalsArJson };
    assetDetailLangUrJson: any = { ...assetDetailUrJson, ...globalsUrJson };
    assetDetailLangPsJson: any = { ...assetDetailPsJson, ...globalsPsJson };

    assetsLangEnJson: any = { ...assetsEnJson, ...globalsEnJson };
    assetsLangArJson: any = { ...assetsArJson, ...globalsArJson };
    assetsLangUrJson: any = { ...assetsUrJson, ...globalsUrJson };
    assetsLangPsJson: any = { ...assetsPsJson, ...globalsPsJson };

    attendanceListLangEnJson: any = { ...attendanceListEnJson, ...globalsEnJson };
    attendanceListLangArJson: any = { ...attendanceListArJson, ...globalsArJson };
    attendanceListLangUrJson: any = { ...attendanceListUrJson, ...globalsUrJson };
    attendanceListLangPsJson: any = { ...attendanceListPsJson, ...globalsPsJson };

    attendanceViewLangEnJson: any = { ...attendanceViewEnJson, ...globalsEnJson };
    attendanceViewLangArJson: any = { ...attendanceViewArJson, ...globalsArJson };
    attendanceViewLangUrJson: any = { ...attendanceViewUrJson, ...globalsUrJson };
    attendanceViewLangPsJson: any = { ...attendanceViewPsJson, ...globalsPsJson };

    bookingLangEnJson: any = { ...bookingEnJson, ...globalsEnJson };
    bookingLangArJson: any = { ...bookingArJson, ...globalsArJson };
    bookingLangUrJson: any = { ...bookingUrJson, ...globalsUrJson };
    bookingLangPsJson: any = { ...bookingPsJson, ...globalsPsJson };

    bookingsLangEnJson: any = { ...bookingsEnJson, ...globalsEnJson };
    bookingsLangArJson: any = { ...bookingsArJson, ...globalsArJson };
    bookingsLangUrJson: any = { ...bookingsUrJson, ...globalsUrJson };
    bookingsLangPsJson: any = { ...bookingsPsJson, ...globalsPsJson };

    bookingSlotLangEnJson: any = { ...bookingSlotEnJson, ...globalsEnJson };
    bookingSlotLangArJson: any = { ...bookingSlotArJson, ...globalsArJson };
    bookingSlotLangUrJson: any = { ...bookingSlotUrJson, ...globalsUrJson };
    bookingSlotLangPsJson: any = { ...bookingSlotPsJson, ...globalsPsJson };

    bookingSlotsLangEnJson: any = { ...bookingSlotsEnJson, ...globalsEnJson };
    bookingSlotsLangArJson: any = { ...bookingSlotsArJson, ...globalsArJson };
    bookingSlotsLangUrJson: any = { ...bookingSlotsUrJson, ...globalsUrJson };
    bookingSlotsLangPsJson: any = { ...bookingSlotsPsJson, ...globalsPsJson };

    addEmployeeLangEnJson: any = { ...addEmployeeEnJson, ...globalsEnJson };
    addEmployeeLangArJson: any = { ...addEmployeeArJson, ...globalsArJson };
    addEmployeeLangUrJson: any = { ...addEmployeeUrJson, ...globalsUrJson };
    addEmployeeLangPsJson: any = { ...addEmployeePsJson, ...globalsPsJson };

    employeesListingLangEnJson: any = { ...employeesListingEnJson, ...globalsEnJson };
    employeesListingLangArJson: any = { ...employeesListingArJson, ...globalsArJson };
    employeesListingLangUrJson: any = { ...employeesListingUrJson, ...globalsUrJson };
    employeesListingLangPsJson: any = { ...employeesListingPsJson, ...globalsPsJson };

    addEnquiryLangEnJson: any = { ...addEnquiryEnJson, ...globalsEnJson };
    addEnquiryLangArJson: any = { ...addEnquiryArJson, ...globalsArJson };
    addEnquiryLangUrJson: any = { ...addEnquiryUrJson, ...globalsUrJson };
    addEnquiryLangPsJson: any = { ...addEnquiryPsJson, ...globalsPsJson };

    enquiryListingLangEnJson: any = { ...enquiryListingEnJson, ...globalsEnJson };
    enquiryListingLangArJson: any = { ...enquiryListingArJson, ...globalsArJson };
    enquiryListingLangUrJson: any = { ...enquiryListingUrJson, ...globalsUrJson };
    enquiryListingLangPsJson: any = { ...enquiryListingPsJson, ...globalsPsJson };

    feeLangEnJson: any = { ...feeEnJson, ...globalsEnJson };
    feeLangArJson: any = { ...feeArJson, ...globalsArJson };
    feeLangUrJson: any = { ...feeUrJson, ...globalsUrJson };
    feeLangPsJson: any = { ...feePsJson, ...globalsPsJson };

    feesLangEnJson: any = { ...feesEnJson, ...globalsEnJson };
    feesLangArJson: any = { ...feesArJson, ...globalsArJson };
    feesLangUrJson: any = { ...feesUrJson, ...globalsUrJson };
    feesLangPsJson: any = { ...feesPsJson, ...globalsPsJson };

    paySalaryToEmployeesLangEnJson: any = { ...paySalaryToEmployeesEnJson, ...globalsEnJson };
    paySalaryToEmployeesLangArJson: any = { ...paySalaryToEmployeesArJson, ...globalsArJson };
    paySalaryToEmployeesLangUrJson: any = { ...paySalaryToEmployeesUrJson, ...globalsUrJson };
    paySalaryToEmployeesLangPsJson: any = { ...paySalaryToEmployeesPsJson, ...globalsPsJson };

    designationManagementLangEnJson: any = { ...designationManagementEnJson, ...globalsEnJson };
    designationManagementLangArJson: any = { ...designationManagementArJson, ...globalsArJson };
    designationManagementLangUrJson: any = { ...designationManagementUrJson, ...globalsUrJson };
    designationManagementLangPsJson: any = { ...designationManagementPsJson, ...globalsPsJson };

    employeeSalaryManagementLangEnJson: any = { ...employeeSalaryManagementEnJson, ...globalsEnJson };
    employeeSalaryManagementLangArJson: any = { ...employeeSalaryManagementArJson, ...globalsArJson };
    employeeSalaryManagementLangUrJson: any = { ...employeeSalaryManagementUrJson, ...globalsUrJson };
    employeeSalaryManagementLangPsJson: any = { ...employeeSalaryManagementPsJson, ...globalsPsJson };

    addMembersLangEnJson: any = { ...addMembersEnJson, ...globalsEnJson };
    addMembersLangArJson: any = { ...addMembersArJson, ...globalsArJson };
    addMembersLangUrJson: any = { ...addMembersUrJson, ...globalsUrJson };
    addMembersLangPsJson: any = { ...addMembersPsJson, ...globalsPsJson };

    cameraLangEnJson: any = { ...cameraEnJson, ...globalsEnJson };
    cameraLangArJson: any = { ...cameraArJson, ...globalsArJson };
    cameraLangUrJson: any = { ...cameraUrJson, ...globalsUrJson };
    cameraLangPsJson: any = { ...cameraPsJson, ...globalsPsJson };

    addFeeLangEnJson: any = { ...addFeeEnJson, ...globalsEnJson };
    addFeeLangArJson: any = { ...addFeeArJson, ...globalsArJson };
    addFeeLangUrJson: any = { ...addFeeUrJson, ...globalsUrJson };
    addFeeLangPsJson: any = { ...addFeePsJson, ...globalsPsJson };

    addFeeMemberLangEnJson: any = { ...addFeeMemberEnJson, ...globalsEnJson };
    addFeeMemberLangArJson: any = { ...addFeeMemberArJson, ...globalsArJson };
    addFeeMemberLangUrJson: any = { ...addFeeMemberUrJson, ...globalsUrJson };
    addFeeMemberLangPsJson: any = { ...addFeeMemberPsJson, ...globalsPsJson };
    bookTrainerLangEnJson: any = { ...bookTrainerEnJson, ...globalsEnJson };
    bookTrainerLangArJson: any = { ...bookTrainerArJson, ...globalsArJson };
    bookTrainerLangUrJson: any = { ...bookTrainerUrJson, ...globalsUrJson };
    bookTrainerLangPsJson: any = { ...bookTrainerPsJson, ...globalsPsJson };
    sessionAttendanceReportLangEnJson: any = {
        ...sessionAttendanceReportEnJson,
        ...globalsEnJson,
    };
    sessionSalesReportLangEnJson: any = {
        ...sessionSalesReportEnJson,
        ...globalsEnJson,
    };
    sessionAttendanceReportLangArJson: any = {
        ...sessionAttendanceReportArJson,
        ...globalsArJson,
    };
    sessionSalesReportLangArJson: any = {
        ...sessionSalesReportArJson,
        ...globalsArJson,
    };
    sessionAttendanceReportLangUrJson: any = {
        ...sessionAttendanceReportUrJson,
        ...globalsUrJson,
    };
    sessionSalesReportLangUrJson: any = {
        ...sessionSalesReportUrJson,
        ...globalsUrJson,
    };
    sessionAttendanceReportLangPsJson: any = {
        ...sessionAttendanceReportPsJson,
        ...globalsPsJson,
    };
    sessionSalesReportLangPsJson: any = {
        ...sessionSalesReportPsJson,
        ...globalsPsJson,
    };
    sessionAttendanceLangEnJson: any = {
        ...sessionAttendanceEnJson,
        ...globalsEnJson,
    };
    sessionAttendanceLangArJson: any = {
        ...sessionAttendanceArJson,
        ...globalsArJson,
    };
    sessionAttendanceLangUrJson: any = {
        ...sessionAttendanceUrJson,
        ...globalsUrJson,
    };
    sessionAttendanceLangPsJson: any = {
        ...sessionAttendancePsJson,
        ...globalsPsJson,
    };

    appPasswordLangEnJson: any = { ...appPasswordEnJson, ...globalsEnJson };
    appPasswordLangArJson: any = { ...appPasswordArJson, ...globalsArJson };
    appPasswordLangUrJson: any = { ...appPasswordUrJson, ...globalsUrJson };
    appPasswordLangPsJson: any = { ...appPasswordPsJson, ...globalsPsJson };

    exportDataLangEnJson: any = { ...exportDataEnJson, ...globalsEnJson };
    exportDataLangArJson: any = { ...exportDataArJson, ...globalsArJson };
    exportDataLangUrJson: any = { ...exportDataUrJson, ...globalsUrJson };
    exportDataLangPsJson: any = { ...exportDataPsJson, ...globalsPsJson };

    feesInvoiceLangEnJson: any = { ...feesInvoiceEnJson, ...globalsEnJson };
    feesInvoiceLangArJson: any = { ...feesInvoiceArJson, ...globalsArJson };
    feesInvoiceLangUrJson: any = { ...feesInvoiceUrJson, ...globalsUrJson };
    feesInvoiceLangPsJson: any = { ...feesInvoicePsJson, ...globalsPsJson };

    emailConfirmationModelLangEnJson: any = { ...emailConfirmationModelEnJson, ...globalsEnJson };
    emailConfirmationModelLangArJson: any = { ...emailConfirmationModelArJson, ...globalsArJson };
    emailConfirmationModelLangUrJson: any = { ...emailConfirmationModelUrJson, ...globalsUrJson };
    emailConfirmationModelLangPsJson: any = { ...emailConfirmationModelPsJson, ...globalsPsJson };

    inactiveMembersLangEnJson: any = { ...inactiveMembersEnJson, ...globalsEnJson };
    inactiveMembersLangArJson: any = { ...inactiveMembersArJson, ...globalsArJson };
    inactiveMembersLangUrJson: any = { ...inactiveMembersUrJson, ...globalsUrJson };
    inactiveMembersLangPsJson: any = { ...inactiveMembersPsJson, ...globalsPsJson };

    membersLangEnJson: any = { ...membersEnJson, ...globalsEnJson };
    membersLangArJson: any = { ...membersArJson, ...globalsArJson };
    membersLangUrJson: any = { ...membersUrJson, ...globalsUrJson };
    membersLangPsJson: any = { ...membersPsJson, ...globalsPsJson };

    packageBuilderLangEnJson: any = { ...packageBuilderEnJson, ...globalsEnJson };
    packageBuilderLangArJson: any = { ...packageBuilderArJson, ...globalsArJson };
    packageBuilderLangUrJson: any = { ...packageBuilderUrJson, ...globalsUrJson };
    packageBuilderLangPsJson: any = { ...packageBuilderPsJson, ...globalsPsJson };

    packageBuildersLangEnJson: any = { ...packageBuildersEnJson, ...globalsEnJson };
    packageBuildersLangArJson: any = { ...packageBuildersArJson, ...globalsArJson };
    packageBuildersLangUrJson: any = { ...packageBuildersUrJson, ...globalsUrJson };
    packageBuildersLangPsJson: any = { ...packageBuildersPsJson, ...globalsPsJson };

    pettyCashLangEnJson: any = { ...pettyCashEnJson, ...globalsEnJson };
    pettyCashLangArJson: any = { ...pettyCashArJson, ...globalsArJson };
    pettyCashLangUrJson: any = { ...pettyCashUrJson, ...globalsUrJson };
    pettyCashLangPsJson: any = { ...pettyCashPsJson, ...globalsPsJson };

    addProductLangEnJson: any = { ...addProductEnJson, ...globalsEnJson };
    addProductLangArJson: any = { ...addProductArJson, ...globalsArJson };
    addProductLangUrJson: any = { ...addProductUrJson, ...globalsUrJson };
    addProductLangPsJson: any = { ...addProductPsJson, ...globalsPsJson };

    productCategoriesLangEnJson: any = { ...productCategoriesEnJson, ...globalsEnJson };
    productCategoriesLangArJson: any = { ...productCategoriesArJson, ...globalsArJson };
    productCategoriesLangUrJson: any = { ...productCategoriesUrJson, ...globalsUrJson };
    productCategoriesLangPsJson: any = { ...productCategoriesPsJson, ...globalsPsJson };

    productCategoryLangEnJson: any = { ...productCategoryEnJson, ...globalsEnJson };
    productCategoryLangArJson: any = { ...productCategoryArJson, ...globalsArJson };
    productCategoryLangUrJson: any = { ...productCategoryUrJson, ...globalsUrJson };
    productCategoryLangPsJson: any = { ...productCategoryPsJson, ...globalsPsJson };

    productsListingLangEnJson: any = { ...productsListingEnJson, ...globalsEnJson };
    productsListingLangArJson: any = { ...productsListingArJson, ...globalsArJson };
    productsListingLangUrJson: any = { ...productsListingUrJson, ...globalsUrJson };
    productsListingLangPsJson: any = { ...productsListingPsJson, ...globalsPsJson };

    updateStockCountLangEnJson: any = { ...updateStockCountEnJson, ...globalsEnJson };
    updateStockCountLangArJson: any = { ...updateStockCountArJson, ...globalsArJson };
    updateStockCountLangUrJson: any = { ...updateStockCountUrJson, ...globalsUrJson };
    updateStockCountLangPsJson: any = { ...updateStockCountPsJson, ...globalsPsJson };

    contactUsLangEnJson: any = { ...contactUsEnJson, ...globalsEnJson };
    contactUsLangArJson: any = { ...contactUsArJson, ...globalsArJson };
    contactUsLangUrJson: any = { ...contactUsUrJson, ...globalsUrJson };
    contactUsLangPsJson: any = { ...contactUsPsJson, ...globalsPsJson };

    loginLogsLangEnJson: any = { ...loginLogsEnJson, ...globalsEnJson };
    loginLogsLangArJson: any = { ...loginLogsArJson, ...globalsArJson };
    loginLogsLangUrJson: any = { ...loginLogsUrJson, ...globalsUrJson };
    loginLogsLangPsJson: any = { ...loginLogsPsJson, ...globalsPsJson };

    activeMemberReportLangEnJson: any = { ...activeMemberReportEnJson, ...globalsEnJson };
    activeMemberReportLangArJson: any = { ...activeMemberReportArJson, ...globalsArJson };
    activeMemberReportLangUrJson: any = { ...activeMemberReportUrJson, ...globalsUrJson };
    activeMemberReportLangPsJson: any = { ...activeMemberReportPsJson, ...globalsPsJson };

    attendenceReportLangEnJson: any = { ...attendenceReportEnJson, ...globalsEnJson };
    attendenceReportLangArJson: any = { ...attendenceReportArJson, ...globalsArJson };
    attendenceReportLangUrJson: any = { ...attendenceReportUrJson, ...globalsUrJson };
    attendenceReportLangPsJson: any = { ...attendenceReportPsJson, ...globalsPsJson };

    checkInReportLangEnJson: any = { ...checkInReportEnJson, ...globalsEnJson };
    checkInReportLangArJson: any = { ...checkInReportArJson, ...globalsArJson };
    checkInReportLangUrJson: any = { ...checkInReportUrJson, ...globalsUrJson };
    checkInReportLangPsJson: any = { ...checkInReportPsJson, ...globalsPsJson };

    dailyClosingReportLangEnJson: any = { ...dailyClosingReportEnJson, ...globalsEnJson };
    dailyClosingReportLangArJson: any = { ...dailyClosingReportArJson, ...globalsArJson };
    dailyClosingReportLangUrJson: any = { ...dailyClosingReportUrJson, ...globalsUrJson };
    dailyClosingReportLangPsJson: any = { ...dailyClosingReportPsJson, ...globalsPsJson };

    defaulterReportLangEnJson: any = { ...defaulterReportEnJson, ...globalsEnJson };
    defaulterReportLangArJson: any = { ...defaulterReportArJson, ...globalsArJson };
    defaulterReportLangUrJson: any = { ...defaulterReportUrJson, ...globalsUrJson };
    defaulterReportLangPsJson: any = { ...defaulterReportPsJson, ...globalsPsJson };

    newMemberReportLangEnJson: any = { ...newMemberReportEnJson, ...globalsEnJson };
    newMemberReportLangArJson: any = { ...newMemberReportArJson, ...globalsArJson };
    newMemberReportLangUrJson: any = { ...newMemberReportUrJson, ...globalsUrJson };
    newMemberReportLangPsJson: any = { ...newMemberReportPsJson, ...globalsPsJson };

    memberReportLangEnJson: any = { ...memberReportEnJson, ...globalsEnJson };
    memberReportLangArJson: any = { ...memberReportArJson, ...globalsArJson };
    memberReportLangUrJson: any = { ...memberReportUrJson, ...globalsUrJson };
    memberReportLangPsJson: any = { ...memberReportPsJson, ...globalsPsJson };

    pOSSalesReportLangEnJson: any = { ...pOSSalesReportEnJson, ...globalsEnJson };
    pOSSalesReportLangArJson: any = { ...pOSSalesReportArJson, ...globalsArJson };
    pOSSalesReportLangUrJson: any = { ...pOSSalesReportUrJson, ...globalsUrJson };
    pOSSalesReportLangPsJson: any = { ...pOSSalesReportPsJson, ...globalsPsJson };

    purchaseHistoryReportsLangEnJson: any = { ...purchaseHistoryReportsEnJson, ...globalsEnJson };
    purchaseHistoryReportsLangArJson: any = { ...purchaseHistoryReportsArJson, ...globalsArJson };
    purchaseHistoryReportsLangUrJson: any = { ...purchaseHistoryReportsUrJson, ...globalsUrJson };
    purchaseHistoryReportsLangPsJson: any = { ...purchaseHistoryReportsPsJson, ...globalsPsJson };

    requestManagementReportsLangEnJson: any = { ...requestManagementReportsEnJson, ...globalsEnJson };
    requestManagementReportsLangArJson: any = { ...requestManagementReportsArJson, ...globalsArJson };
    requestManagementReportsLangUrJson: any = { ...requestManagementReportsUrJson, ...globalsUrJson };
    requestManagementReportsLangPsJson: any = { ...requestManagementReportsPsJson, ...globalsPsJson };

    pointOfSaleLangEnJson: any = { ...pointOfSaleEnJson, ...globalsEnJson };
    pointOfSaleLangArJson: any = { ...pointOfSaleArJson, ...globalsArJson };
    pointOfSaleLangUrJson: any = { ...pointOfSaleUrJson, ...globalsUrJson };
    pointOfSaleLangPsJson: any = { ...pointOfSalePsJson, ...globalsPsJson };

    salesReportsLangEnJson: any = { ...salesReportsEnJson, ...globalsEnJson };
    salesReportsLangArJson: any = { ...salesReportsArJson, ...globalsArJson };
    salesReportsLangUrJson: any = { ...salesReportsUrJson, ...globalsUrJson };
    salesReportsLangPsJson: any = { ...salesReportsPsJson, ...globalsPsJson };

    trainerSalesReportLangEnJson: any = { ...trainerSalesReportEnJson, ...globalsEnJson };
    trainerSalesReportLangArJson: any = { ...trainerSalesReportArJson, ...globalsArJson };
    trainerSalesReportLangUrJson: any = { ...trainerSalesReportUrJson, ...globalsUrJson };
    trainerSalesReportLangPsJson: any = { ...trainerSalesReportPsJson, ...globalsPsJson };

    trainerClientsReportLangEnJson: any = { ...trainerClientsReportEnJson, ...globalsEnJson };
    trainerClientsReportLangArJson: any = { ...trainerClientsReportArJson, ...globalsArJson };
    trainerClientsReportLangUrJson: any = { ...trainerClientsReportUrJson, ...globalsUrJson };
    trainerClientsReportLangPsJson: any = { ...trainerClientsReportPsJson, ...globalsPsJson };

    trainerSessionReportLangEnJson: any = { ...trainerSessionReportEnJson, ...globalsEnJson };
    trainerSessionReportLangArJson: any = { ...trainerSessionReportArJson, ...globalsArJson };
    trainerSessionReportLangUrJson: any = { ...trainerSessionReportUrJson, ...globalsUrJson };
    trainerSessionReportLangPsJson: any = { ...trainerSessionReportPsJson, ...globalsPsJson };

    trainingAttendenceReportLangEnJson: any = { ...trainingAttendenceReportEnJson, ...globalsEnJson };
    trainingAttendenceReportLangArJson: any = { ...trainingAttendenceReportArJson, ...globalsArJson };
    trainingAttendenceReportLangUrJson: any = { ...trainingAttendenceReportUrJson, ...globalsUrJson };
    trainingAttendenceReportLangPsJson: any = { ...trainingAttendenceReportPsJson, ...globalsPsJson };

    upcomingBirthdaysReportLangEnJson: any = { ...upcomingBirthdaysReportEnJson, ...globalsEnJson };
    upcomingBirthdaysReportLangArJson: any = { ...upcomingBirthdaysReportArJson, ...globalsArJson };
    upcomingBirthdaysReportLangUrJson: any = { ...upcomingBirthdaysReportUrJson, ...globalsUrJson };
    upcomingBirthdaysReportLangPsJson: any = { ...upcomingBirthdaysReportPsJson, ...globalsPsJson };

    upcomingDuesReportLangEnJson: any = { ...upcomingDuesReportEnJson, ...globalsEnJson };
    upcomingDuesReportLangArJson: any = { ...upcomingDuesReportArJson, ...globalsArJson };
    upcomingDuesReportLangUrJson: any = { ...upcomingDuesReportUrJson, ...globalsUrJson };
    upcomingDuesReportLangPsJson: any = { ...upcomingDuesReportPsJson, ...globalsPsJson };

    usersAttendanceReportLangEnJson: any = { ...usersAttendanceReportEnJson, ...globalsEnJson };
    usersAttendanceReportLangArJson: any = { ...usersAttendanceReportArJson, ...globalsArJson };
    usersAttendanceReportLangUrJson: any = { ...usersAttendanceReportUrJson, ...globalsUrJson };
    usersAttendanceReportLangPsJson: any = { ...usersAttendanceReportPsJson, ...globalsPsJson };

    reportsLangEnJson: any = { ...reportsEnJson, ...globalsEnJson };
    reportsLangArJson: any = { ...reportsArJson, ...globalsArJson };
    reportsLangUrJson: any = { ...reportsUrJson, ...globalsUrJson };
    reportsLangPsJson: any = { ...reportsPsJson, ...globalsPsJson };

    feeSubmissionRequestDetailLangEnJson: any = { ...feeSubmissionRequestDetailEnJson, ...globalsEnJson };
    feeSubmissionRequestDetailLangArJson: any = { ...feeSubmissionRequestDetailArJson, ...globalsArJson };
    feeSubmissionRequestDetailLangUrJson: any = { ...feeSubmissionRequestDetailUrJson, ...globalsUrJson };
    feeSubmissionRequestDetailLangPsJson: any = { ...feeSubmissionRequestDetailPsJson, ...globalsPsJson };

    memberRequestDetailLangEnJson: any = { ...memberRequestDetailEnJson, ...globalsEnJson };
    memberRequestDetailLangArJson: any = { ...memberRequestDetailArJson, ...globalsArJson };
    memberRequestDetailLangUrJson: any = { ...memberRequestDetailUrJson, ...globalsUrJson };
    memberRequestDetailLangPsJson: any = { ...memberRequestDetailPsJson, ...globalsPsJson };

    requestsManagementLangEnJson: any = { ...requestsManagementEnJson, ...globalsEnJson };
    requestsManagementLangArJson: any = { ...requestsManagementArJson, ...globalsArJson };
    requestsManagementLangUrJson: any = { ...requestsManagementUrJson, ...globalsUrJson };
    requestsManagementLangPsJson: any = { ...requestsManagementPsJson, ...globalsPsJson };

    saleOrdersLangEnJson: any = { ...saleOrdersEnJson, ...globalsEnJson };
    saleOrdersLangArJson: any = { ...saleOrdersArJson, ...globalsArJson };
    saleOrdersLangUrJson: any = { ...saleOrdersUrJson, ...globalsUrJson };
    saleOrdersLangPsJson: any = { ...saleOrdersPsJson, ...globalsPsJson };

    branchLangEnJson: any = { ...branchEnJson, ...globalsEnJson };
    branchLangArJson: any = { ...branchArJson, ...globalsArJson };
    branchLangUrJson: any = { ...branchUrJson, ...globalsUrJson };
    branchLangPsJson: any = { ...branchPsJson, ...globalsPsJson };

    branchesLangEnJson: any = { ...branchesEnJson, ...globalsEnJson };
    branchesLangArJson: any = { ...branchesArJson, ...globalsArJson };
    branchesLangUrJson: any = { ...branchesUrJson, ...globalsUrJson };
    branchesLangPsJson: any = { ...branchesPsJson, ...globalsPsJson };

    registerBranchFromCompanyLangEnJson: any = { ...registerBranchFromCompanyEnJson, ...globalsEnJson };
    registerBranchFromCompanyLangArJson: any = { ...registerBranchFromCompanyArJson, ...globalsArJson };
    registerBranchFromCompanyLangUrJson: any = { ...registerBranchFromCompanyUrJson, ...globalsUrJson };
    registerBranchFromCompanyLangPsJson: any = { ...registerBranchFromCompanyPsJson, ...globalsPsJson };

    companiesLangEnJson: any = { ...companiesEnJson, ...globalsEnJson };
    companiesLangArJson: any = { ...companiesArJson, ...globalsArJson };
    companiesLangUrJson: any = { ...companiesUrJson, ...globalsUrJson };
    companiesLangPsJson: any = { ...companiesPsJson, ...globalsPsJson };

    companyLangEnJson: any = { ...companyEnJson, ...globalsEnJson };
    companyLangArJson: any = { ...companyArJson, ...globalsArJson };
    companyLangUrJson: any = { ...companyUrJson, ...globalsUrJson };
    companyLangPsJson: any = { ...companyPsJson, ...globalsPsJson };

    userPasswordLangEnJson: any = { ...userPasswordEnJson, ...globalsEnJson };
    userPasswordLangArJson: any = { ...userPasswordArJson, ...globalsArJson };
    userPasswordLangUrJson: any = { ...userPasswordUrJson, ...globalsUrJson };
    userPasswordLangPsJson: any = { ...userPasswordPsJson, ...globalsPsJson };

    permissionLangEnJson: any = { ...permissionEnJson, ...globalsEnJson };
    permissionLangArJson: any = { ...permissionArJson, ...globalsArJson };
    permissionLangUrJson: any = { ...permissionUrJson, ...globalsUrJson };
    permissionLangPsJson: any = { ...permissionPsJson, ...globalsPsJson };

    permissionsLangEnJson: any = { ...permissionsEnJson, ...globalsEnJson };
    permissionsLangArJson: any = { ...permissionsArJson, ...globalsArJson };
    permissionsLangUrJson: any = { ...permissionsUrJson, ...globalsUrJson };
    permissionsLangPsJson: any = { ...permissionsPsJson, ...globalsPsJson };

    roleLangEnJson: any = { ...roleEnJson, ...globalsEnJson };
    roleLangArJson: any = { ...roleArJson, ...globalsArJson };
    roleLangUrJson: any = { ...roleUrJson, ...globalsUrJson };
    roleLangPsJson: any = { ...rolePsJson, ...globalsPsJson };

    rolesLangEnJson: any = { ...rolesEnJson, ...globalsEnJson };
    rolesLangArJson: any = { ...rolesArJson, ...globalsArJson };
    rolesLangUrJson: any = { ...rolesUrJson, ...globalsUrJson };
    rolesLangPsJson: any = { ...rolesPsJson, ...globalsPsJson };

    userLangEnJson: any = { ...userEnJson, ...globalsEnJson };
    userLangArJson: any = { ...userArJson, ...globalsArJson };
    userLangUrJson: any = { ...userUrJson, ...globalsUrJson };
    userLangPsJson: any = { ...userPsJson, ...globalsPsJson };

    trainerPackagesLangEnJson: any = { ...trainerPackagesEnJson, ...globalsEnJson };
    trainerPackagesLangArJson: any = { ...trainerPackagesArJson, ...globalsArJson };
    trainerPackagesLangUrJson: any = { ...trainerPackagesUrJson, ...globalsUrJson };
    trainerPackagesLangPsJson: any = { ...trainerPackagesPsJson, ...globalsPsJson };
    trainerScheduleLangEnJson: any = { ...trainerScheduleEnJson, ...globalsEnJson };
    trainerScheduleLangArJson: any = { ...trainerScheduleArJson, ...globalsArJson };
    trainerScheduleLangUrJson: any = { ...trainerScheduleUrJson, ...globalsUrJson };
    trainerScheduleLangPsJson: any = { ...trainerSchedulePsJson, ...globalsPsJson };
    trainerModuleSettingsLangEnJson: any = { ...trainerModuleSettingsEnJson, ...globalsEnJson };
    trainerModuleSettingsLangArJson: any = { ...trainerModuleSettingsArJson, ...globalsArJson };
    trainerModuleSettingsLangUrJson: any = { ...trainerModuleSettingsUrJson, ...globalsUrJson };
    trainerModuleSettingsLangPsJson: any = { ...trainerModuleSettingsPsJson, ...globalsPsJson };

    usersLangEnJson: any = { ...usersEnJson, ...globalsEnJson };
    usersLangArJson: any = { ...usersArJson, ...globalsArJson };
    usersLangUrJson: any = { ...usersUrJson, ...globalsUrJson };
    usersLangPsJson: any = { ...usersPsJson, ...globalsPsJson };

    receiptPrintLangEnJson: any = { ...receiptPrintEnJson, ...globalsEnJson };
    receiptPrintLangArJson: any = { ...receiptPrintArJson, ...globalsArJson };
    receiptPrintLangUrJson: any = { ...receiptPrintUrJson, ...globalsUrJson };
    receiptPrintLangPsJson: any = { ...receiptPrintPsJson, ...globalsPsJson };

    singleReceiptPrintLangEnJson: any = { ...singleReceiptPrintEnJson, ...globalsEnJson };
    singleReceiptPrintLangArJson: any = { ...singleReceiptPrintArJson, ...globalsArJson };
    singleReceiptPrintLangUrJson: any = { ...singleReceiptPrintUrJson, ...globalsUrJson };
    singleReceiptPrintLangPsJson: any = { ...singleReceiptPrintPsJson, ...globalsPsJson };

    singleReceiptEmailLangEnJson: any = { ...singleReceiptEmailEnJson, ...globalsEnJson };
    singleReceiptEmailLangArJson: any = { ...singleReceiptEmailArJson, ...globalsArJson };
    singleReceiptEmailLangUrJson: any = { ...singleReceiptEmailUrJson, ...globalsUrJson };
    singleReceiptEmailLangPsJson: any = { ...singleReceiptEmailPsJson, ...globalsPsJson };

    signupLangEnJson: any = { ...signupEnJson, ...globalsEnJson };
    signupLangArJson: any = { ...signupArJson, ...globalsArJson };
    signupLangUrJson: any = { ...signupUrJson, ...globalsUrJson };
    signupLangPsJson: any = { ...signupPsJson, ...globalsPsJson };

    addSingleSignupLangEnJson: any = { ...addSingleSignupEnJson, ...globalsEnJson };
    addSingleSignupLangArJson: any = { ...addSingleSignupArJson, ...globalsArJson };
    addSingleSignupLangUrJson: any = { ...addSingleSignupUrJson, ...globalsUrJson };
    addSingleSignupLangPsJson: any = { ...addSingleSignupPsJson, ...globalsPsJson };

    addMultipleSignupLangEnJson: any = { ...addMultipleSignupEnJson, ...globalsEnJson };
    addMultipleSignupLangArJson: any = { ...addMultipleSignupArJson, ...globalsArJson };
    addMultipleSignupLangUrJson: any = { ...addMultipleSignupUrJson, ...globalsUrJson };
    addMultipleSignupLangPsJson: any = { ...addMultipleSignupPsJson, ...globalsPsJson };

    inActiveMemberReportLangEnJson: any = { ...inActiveMemberReportEnJson, ...globalsEnJson };
    inActiveMemberReportLangArJson: any = { ...inActiveMemberReportArJson, ...globalsArJson };
    inActiveMemberReportLangUrJson: any = { ...inActiveMemberReportUrJson, ...globalsUrJson };
    inActiveMemberReportLangPsJson: any = { ...inActiveMemberReportPsJson, ...globalsPsJson };

    enquiryManagementReportLangEnJson: any = { ...enquiryManagementReportEnJson, ...globalsEnJson };
    enquiryManagementReportLangArJson: any = { ...enquiryManagementReportArJson, ...globalsArJson };
    enquiryManagementReportLangUrJson: any = { ...enquiryManagementReportUrJson, ...globalsUrJson };
    enquiryManagementReportLangPsJson: any = { ...enquiryManagementReportPsJson, ...globalsPsJson };

    addSupplierLangEnJson: any = { ...addSupplierEnJson, ...globalsEnJson };
    addSupplierLangArJson: any = { ...addSupplierArJson, ...globalsArJson };
    addSupplierLangUrJson: any = { ...addSupplierUrJson, ...globalsUrJson };
    addSupplierLangPsJson: any = { ...addSupplierPsJson, ...globalsPsJson };

    purchaseOrderLangEnJson: any = { ...purchaseOrderEnJson, ...globalsEnJson };
    purchaseOrderLangArJson: any = { ...purchaseOrderArJson, ...globalsArJson };
    purchaseOrderLangUrJson: any = { ...purchaseOrderUrJson, ...globalsUrJson };
    purchaseOrderLangPsJson: any = { ...purchaseOrderPsJson, ...globalsPsJson };

    purchaseOrdersLangEnJson: any = { ...purchaseOrdersEnJson, ...globalsEnJson };
    purchaseOrdersLangArJson: any = { ...purchaseOrdersArJson, ...globalsArJson };
    purchaseOrdersLangUrJson: any = { ...purchaseOrdersUrJson, ...globalsUrJson };
    purchaseOrdersLangPsJson: any = { ...purchaseOrdersPsJson, ...globalsPsJson };

    supplierListingLangEnJson: any = { ...supplierListingEnJson, ...globalsEnJson };
    supplierListingLangArJson: any = { ...supplierListingArJson, ...globalsArJson };
    supplierListingLangUrJson: any = { ...supplierListingUrJson, ...globalsUrJson };
    supplierListingLangPsJson: any = { ...supplierListingPsJson, ...globalsPsJson };

    membersTrainingAttendenceLangEnJson: any = { ...membersTrainingAttendanceEnJson, ...globalsEnJson };
    membersTrainingAttendenceLangArJson: any = { ...membersTrainingAttendanceArJson, ...globalsArJson };
    membersTrainingAttendenceLangUrJson: any = { ...membersTrainingAttendanceUrJson, ...globalsUrJson };
    membersTrainingAttendenceLangPsJson: any = { ...membersTrainingAttendancePsJson, ...globalsPsJson };

    membersTrainingAttendenceViewLangEnJson: any = { ...membersTrainingAttendanceViewEnJson, ...globalsEnJson };
    membersTrainingAttendenceViewLangArJson: any = { ...membersTrainingAttendanceViewArJson, ...globalsArJson };
    membersTrainingAttendenceViewLangUrJson: any = { ...membersTrainingAttendanceViewUrJson, ...globalsUrJson };
    membersTrainingAttendenceViewLangPsJson: any = { ...membersTrainingAttendanceViewPsJson, ...globalsPsJson };

    addVisitorLangEnJson: any = { ...addVisitorEnJson, ...globalsEnJson };
    addVisitorLangArJson: any = { ...addVisitorArJson, ...globalsArJson };
    addVisitorLangUrJson: any = { ...addVisitorUrJson, ...globalsUrJson };
    addVisitorLangPsJson: any = { ...addVisitorPsJson, ...globalsPsJson };

    visitorDialogueLangEnJson: any = { ...visitorDialogueEnJson, ...globalsEnJson };
    visitorDialogueLangArJson: any = { ...visitorDialogueArJson, ...globalsArJson };
    visitorDialogueLangUrJson: any = { ...visitorDialogueUrJson, ...globalsUrJson };
    visitorDialogueLangPsJson: any = { ...visitorDialoguePsJson, ...globalsPsJson };

    visitorRequestDetailLangEnJson: any = { ...visitorRequestDetailEnJson, ...globalsEnJson };
    visitorRequestDetailLangArJson: any = { ...visitorRequestDetailArJson, ...globalsArJson };
    visitorRequestDetailLangUrJson: any = { ...visitorRequestDetailUrJson, ...globalsUrJson };
    visitorRequestDetailLangPsJson: any = { ...visitorRequestDetailPsJson, ...globalsPsJson };

    freezeRequestDetailLangEnJson: any = { ...freezeRequestDetailEnJson, ...globalsEnJson };
    freezeRequestDetailLangArJson: any = { ...freezeRequestDetailArJson, ...globalsArJson };
    freezeRequestDetailLangUrJson: any = { ...freezeRequestDetailUrJson, ...globalsUrJson };
    freezeRequestDetailLangPsJson: any = { ...freezeRequestDetailPsJson, ...globalsPsJson };

    visitorReportLangEnJson: any = { ...visitorReportEnJson, ...globalsEnJson };
    visitorReportLangArJson: any = { ...visitorReportArJson, ...globalsArJson };
    visitorReportLangUrJson: any = { ...visitorReportUrJson, ...globalsUrJson };
    visitorReportLangPsJson: any = { ...visitorReportPsJson, ...globalsPsJson };

    globalLangEnJson: any = { ...globalEnJson, ...globalsEnJson };
    globalLangArJson: any = { ...globalArJson, ...globalsArJson };
    globalLangUrJson: any = { ...globalUrJson, ...globalsUrJson };
    globalLangPsJson: any = { ...globalPsJson, ...globalsPsJson };

    closingReportLangEnJson: any = { ...closingReportEnJson, ...globalsEnJson };
    closingReportLangArJson: any = { ...closingReportArJson, ...globalsArJson };
    closingReportLangUrJson: any = { ...closingReportUrJson, ...globalsUrJson };
    closingReportLangPsJson: any = { ...closingReportPsJson, ...globalsPsJson };

    userInformationLangEnJson: any = { ...userInformationEnJson, ...globalsEnJson };
    userInformationLangArJson: any = { ...userInformationArJson, ...globalsArJson };
    userInformationLangUrJson: any = { ...userInformationUrJson, ...globalsUrJson };
    userInformationLangPsJson: any = { ...userInformationPsJson, ...globalsPsJson };

    notificationLangEnJson: any = { ...notificationEnJson, ...globalsEnJson };
    notificationLangArJson: any = { ...notificationArJson, ...globalsArJson };
    notificationLangUrJson: any = { ...notificationUrJson, ...globalsUrJson };
    notificationLangPsJson: any = { ...notificationPsJson, ...globalsPsJson };

    notificationsLangEnJson: any = { ...notificationsEnJson, ...globalsEnJson };
    notificationsLangArJson: any = { ...notificationsArJson, ...globalsArJson };
    notificationsLangUrJson: any = { ...notificationsUrJson, ...globalsUrJson };
    notificationsLangPsJson: any = { ...notificationsPsJson, ...globalsPsJson };

    addTrainerLangEnJson: any = { ...addTrainerEnJson, ...globalsEnJson };
    addTrainerLangArJson: any = { ...addTrainerArJson, ...globalsArJson };
    addTrainerLangUrJson: any = { ...addTrainerUrJson, ...globalsUrJson };
    addTrainerLangPsJson: any = { ...addTrainerPsJson, ...globalsPsJson };

    trainersLangEnJson: any = { ...trainersEnJson, ...globalsEnJson };
    trainersLangArJson: any = { ...trainersArJson, ...globalsArJson };
    trainersLangUrJson: any = { ...trainersUrJson, ...globalsUrJson };
    trainersLangPsJson: any = { ...trainersPsJson, ...globalsPsJson };

    appFormFieldsLangEnJson: any = { ...appFormFieldsEnJson, ...globalsEnJson };
    appFormFieldsLangArJson: any = { ...appFormFieldsArJson, ...globalsArJson };
    appFormFieldsLangUrJson: any = { ...appFormFieldsUrJson, ...globalsUrJson };
    appFormFieldsLangPsJson: any = { ...appFormFieldsPsJson, ...globalsPsJson };

    trainerAttendanceReportLangEnJson: any = { ...trainerAttendanceReportEnJson, ...globalsEnJson };
    trainerAttendanceReportLangArJson: any = { ...trainerAttendanceReportArJson, ...globalsArJson };
    trainerAttendanceReportLangUrJson: any = { ...trainerAttendanceReportUrJson, ...globalsUrJson };
    trainerAttendanceReportLangPsJson: any = { ...trainerAttendanceReportPsJson, ...globalsPsJson };

    trainerDefaulterLangEnJson: any = { ...trainerDefaulterEnJson, ...globalsEnJson };
    trainerDefaulterLangArJson: any = { ...trainerDefaulterArJson, ...globalsArJson };
    trainerDefaulterLangUrJson: any = { ...trainerDefaulterUrJson, ...globalsUrJson };
    trainerDefaulterLangPsJson: any = { ...trainerDefaulterPsJson, ...globalsPsJson };

    subscriptionDefaulterReportLangEnJson: any = { ...subscriptionDefaulterReportEnJson, ...globalsEnJson };
    subscriptionDefaulterReportLangArJson: any = { ...subscriptionDefaulterReportArJson, ...globalsArJson };
    subscriptionDefaulterReportLangUrJson: any = { ...subscriptionDefaulterReportUrJson, ...globalsUrJson };
    subscriptionDefaulterReportLangPsJson: any = { ...subscriptionDefaulterReportPsJson, ...globalsPsJson };

    complainsLangEnJson: any = { ...complainsEnJson, ...globalsEnJson };
    complainsLangArJson: any = { ...complainsArJson, ...globalsArJson };
    complainsLangUrJson: any = { ...complainsUrJson, ...globalsUrJson };
    complainsLangPsJson: any = { ...complainsPsJson, ...globalsPsJson };

    permissionVisitorLangEnJson: any = { ...permissionVisitorEnJson, ...globalsEnJson };
    permissionVisitorLangArJson: any = { ...permissionVisitorArJson, ...globalsArJson };
    permissionVisitorLangUrJson: any = { ...permissionVisitorUrJson, ...globalsUrJson };
    permissionVisitorLangPsJson: any = { ...permissionVisitorPsJson, ...globalsPsJson };

    addpackageBuilderLangEnJson: any = { ...addpackageBuilderEnJson, ...globalsEnJson };
    addpackageBuilderLangArJson: any = { ...addpackageBuilderArJson, ...globalsArJson };
    addpackageBuilderLangUrJson: any = { ...addpackageBuilderUrJson, ...globalsUrJson };
    addpackageBuilderLangPsJson: any = { ...addpackageBuilderPsJson, ...globalsPsJson };

    registerCompanyLangEnJson: any = { ...registerCompanyEnJson, ...globalsEnJson };
    registerCompanyLangArJson: any = { ...registerCompanyArJson, ...globalsArJson };
    registerCompanyLangUrJson: any = { ...registerCompanyUrJson, ...globalsUrJson };
    registerCompanyLangPsJson: any = { ...registerCompanyPsJson, ...globalsPsJson };

    addServicesLangEnJson: any = { ...addServicesEnJson, ...globalsEnJson };
    addServicesLangArJson: any = { ...addServicesArJson, ...globalsArJson };
    addServicesLangUrJson: any = { ...addServicesUrJson, ...globalsUrJson };
    addServicesLangPsJson: any = { ...addServicesPsJson, ...globalsPsJson };

    trainingServiceLangEnJson: any = { ...trainingServiceEnJson, ...globalsEnJson };
    trainingServiceLangArJson: any = { ...trainingServiceArJson, ...globalsArJson };
    trainingServiceLangUrJson: any = { ...trainingServiceUrJson, ...globalsUrJson };
    trainingServiceLangPsJson: any = { ...trainingServicePsJson, ...globalsPsJson };

    servicesLangEnJson: any = { ...servicesEnJson, ...globalsEnJson };
    servicesLangArJson: any = { ...servicesArJson, ...globalsArJson };
    servicesLangUrJson: any = { ...servicesUrJson, ...globalsUrJson };
    servicesLangPsJson: any = { ...servicesPsJson, ...globalsPsJson };


    selfServicesLangEnJson: any = { ...selfServicesEnJson, ...globalsEnJson };
    selfServicesLangArJson: any = { ...selfServicesArJson, ...globalsArJson };
    selfServicesLangUrJson: any = { ...selfServicesUrJson, ...globalsUrJson };
    selfServicesLangPsJson: any = { ...selfServicesPsJson, ...globalsPsJson };

    appRightpanelLangEnJson: any = { ...appRightpanelEnJson, ...globalsEnJson };
    appRightpanelLangArJson: any = { ...appRightpanelArJson, ...globalsArJson };
    appRightpanelLangUrJson: any = { ...appRightpanelUrJson, ...globalsUrJson };
    appRightpanelLangPsJson: any = { ...appRightpanelPsJson, ...globalsPsJson };

    trainingSessionsLangEnJson: any = { ...trainingSessionsEnJson, ...globalsEnJson };
    trainingSessionsLangArJson: any = { ...trainingSessionsArJson, ...globalsArJson };
    trainingSessionsLangUrJson: any = { ...trainingSessionsUrJson, ...globalsUrJson };
    trainingSessionsLangPsJson: any = { ...trainingSessionsPsJson, ...globalsPsJson };

    trainerPayoutLangEnJson: any = { ...trainerPayoutEnJson, ...globalsEnJson };
    trainerPayoutLangArJson: any = { ...trainerPayoutArJson, ...globalsArJson };
    trainerPayoutLangUrJson: any = { ...trainerPayoutUrJson, ...globalsUrJson };
    trainerPayoutLangPsJson: any = { ...trainerPayoutPsJson, ...globalsPsJson };

    trainerDashboardLangEnJson: any = { ...trainerDashboardEnJson, ...globalsEnJson };
    trainerDashboardLangArJson: any = { ...trainerDashboardArJson, ...globalsArJson };
    trainerDashboardLangUrJson: any = { ...trainerDashboardUrJson, ...globalsUrJson };
    trainerDashboardLangPsJson: any = { ...trainerDashboardPsJson, ...globalsPsJson };

    trainingSessionAttdLangEnJson: any = { ...trainingSessionAttdEnJson, ...globalsEnJson };
    trainingSessionAttdLangArJson: any = { ...trainingSessionAttdArJson, ...globalsArJson };
    trainingSessionAttdLangUrJson: any = { ...trainingSessionAttdUrJson, ...globalsUrJson };
    trainingSessionAttdLangPsJson: any = { ...trainingSessionAttdPsJson, ...globalsPsJson };

    appTopbarLangEnJson: any = { ...appTopbarEnJson, ...globalsEnJson };
    appTopbarLangArJson: any = { ...appTopbarArJson, ...globalsArJson };
    appTopbarLangUrJson: any = { ...appTopbarUrJson, ...globalsUrJson };
    appTopbarLangPsJson: any = { ...appTopbarPsJson, ...globalsPsJson };

    feeCollectLangEnJson: any = { ...feeCollectEnJson, ...globalsEnJson };
    feeCollectLangArJson: any = { ...feeCollectArJson, ...globalsArJson };
    feeCollectLangUrJson: any = { ...feeCollectUrJson, ...globalsUrJson };
    feeCollectLangPsJson: any = { ...feeCollectPsJson, ...globalsPsJson };

    paymentLangEnJson: any = { ...paymentEnJson, ...globalsEnJson };
    paymentLangArJson: any = { ...paymentArJson, ...globalsArJson };
    paymentLangUrJson: any = { ...paymentUrJson, ...globalsUrJson };
    paymentLangPsJson: any = { ...paymentPsJson, ...globalsPsJson };

    appLoginLangEnJson: any = { ...appLoginEnJson, ...globalsEnJson };
    appLoginLangArJson: any = { ...appLoginArJson, ...globalsArJson };
    appLoginLangUrJson: any = { ...appLoginUrJson, ...globalsUrJson };
    appLoginLangPsJson: any = { ...appLoginPsJson, ...globalsPsJson };


    employeesPayoutLangEnJson: any = { ...employeesPayoutEnJson, ...globalsEnJson };
    employeesPayoutLangArJson: any = { ...employeesPayoutArJson, ...globalsArJson };
    employeesPayoutLangUrJson: any = { ...employeesPayoutUrJson, ...globalsUrJson };
    employeesPayoutLangPsJson: any = { ...employeesPayoutPsJson, ...globalsPsJson };


    quotationsLangEnJson: any = { ...quotationsEnJson, ...globalsEnJson };
    quotationsLangArJson: any = { ...quotationsArJson, ...globalsArJson };
    quotationsLangUrJson: any = { ...quotationsUrJson, ...globalsUrJson };
    quotationsLangPsJson: any = { ...quotationsPsJson, ...globalsPsJson };

    constructor() {
        const language = localStorage.getItem("Lang");
        if (language) {
            this.lang = language;
        }
    }

    English(label, componentName) {
        if (componentName === "DashboardComponent") {
            return this.dashboardLangEnJson[label];
        }
        if (componentName === "VisitorsComponent") {
            return this.visitorsLangEnJson[label];
        }
        if (componentName === "ActivityLogsComponent") {
            return this.activityLogsLangEnJson[label];
        }
        if (componentName === "AddAssetComponent") {
            return this.addAssetLangEnJson[label];
        }
        if (componentName === "AssetDetailsComponent") {
            return this.assetDetailLangEnJson[label];
        }
        if (componentName === "AssetsComponent") {
            return this.assetsLangEnJson[label];
        }
        if (componentName === "AttendanceListComponent") {
            return this.attendanceListLangEnJson[label];
        }
        if (componentName === "AttendanceViewComponent") {
            return this.attendanceViewLangEnJson[label];
        }
        if (componentName === "BookingComponent") {
            return this.bookingLangEnJson[label];
        }
        if (componentName === "BookingsComponent") {
            return this.bookingsLangEnJson[label];
        }
        if (componentName === "BookingSlotComponent") {
            return this.bookingSlotLangEnJson[label];
        }
        if (componentName === "BookingSlotsComponent") {
            return this.bookingSlotsLangEnJson[label];
        }
        if (componentName === "AddEmployeeComponent") {
            return this.addEmployeeLangEnJson[label];
        }
        if (componentName === "EmployeesListingComponent") {
            return this.employeesListingLangEnJson[label];
        }
        if (componentName === "AddEnquiryComponent") {
            return this.addEnquiryLangEnJson[label];
        }
        if (componentName === "EnquiryListingComponent") {
            return this.enquiryListingLangEnJson[label];
        }
        if (componentName === "FeeComponent") {
            return this.feeLangEnJson[label];
        }
        if (componentName === "FeesComponent") {
            return this.feesLangEnJson[label];
        }
        if (componentName === "PaySalaryToEmployeesComponent") {
            return this.paySalaryToEmployeesLangEnJson[label];
        }
        if (componentName === "DesignationManagementComponent") {
            return this.designationManagementLangEnJson[label];
        }
        if (componentName === "EmployeeSalaryManagementComponent") {
            return this.employeeSalaryManagementLangEnJson[label];
        }
        if (componentName === "AddMembersComponent") {
            return this.addMembersLangEnJson[label];
        }
        if (componentName === "CameraComponent") {
            return this.cameraLangEnJson[label];
        }
        if (componentName === "AddFeeComponent") {
            return this.addFeeLangEnJson[label];
        }
        if (componentName === "AddFeeMemberComponent") {
            return this.addFeeMemberLangEnJson[label];
        }
        if (componentName === "BookTrainerComponent") {
            return this.bookTrainerLangEnJson[label];
        }
        if (componentName === "SessionAttendanceReportComponent") {
            return this.sessionAttendanceReportLangEnJson[label];
        }
        if (componentName === "SessionSalesReportComponent") {
            return this.sessionSalesReportLangEnJson[label];
        }
        if (componentName === "SessionAttendanceComponent") {
            return this.sessionAttendanceLangEnJson[label];
        }
        if (componentName === "AppPasswordComponent") {
            return this.appPasswordLangEnJson[label];
        }
        if (componentName === "ExportDataComponent") {
            return this.exportDataLangEnJson[label];
        }
        if (componentName === "FeesInvoiceComponent") {
            return this.feesInvoiceLangEnJson[label];
        }
        if (componentName === "EmailConfirmationModalComponent") {
            return this.emailConfirmationModelLangEnJson[label];
        }
        if (componentName === "InactiveMembersComponent") {
            return this.inactiveMembersLangEnJson[label];
        }
        if (componentName === "MembersComponent") {
            return this.membersLangEnJson[label];
        }
        if (componentName === "PackageBuilderComponent") {
            return this.packageBuilderLangEnJson[label];
        }
        if (componentName === "PackageBuildersComponent") {
            return this.packageBuildersLangEnJson[label];
        }
        if (componentName === "PettyCashComponent") {
            return this.pettyCashLangEnJson[label];
        }
        if (componentName === "AddProductComponent") {
            return this.addProductLangEnJson[label];
        }
        if (componentName === "ProductCategoriesComponent") {
            return this.productCategoriesLangEnJson[label];
        }
        if (componentName === "ProductCategoryComponent") {
            return this.productCategoryLangEnJson[label];
        }
        if (componentName === "ProductsListingComponent") {
            return this.productsListingLangEnJson[label];
        }
        if (componentName === "UpdateStockCountComponent") {
            return this.updateStockCountLangEnJson[label];
        }
        if (componentName === "ContactUsComponent") {
            return this.contactUsLangEnJson[label];
        }
        if (componentName === "LoginLogsComponent") {
            return this.loginLogsLangEnJson[label];
        }
        if (componentName === "ActiveMemberReportComponent") {
            return this.activeMemberReportLangEnJson[label];
        }
        if (componentName === "AttendenceReportComponent") {
            return this.attendenceReportLangEnJson[label];
        }
        if (componentName === "CheckInReportComponent") {
            return this.checkInReportLangEnJson[label];
        }
        if (componentName === "DailyClosingReportComponent") {
            return this.dailyClosingReportLangEnJson[label];
        }
        if (componentName === "DefaulterReportComponent") {
            return this.defaulterReportLangEnJson[label];
        }
        if (componentName === "MemberReportComponent") {
            return this.memberReportLangEnJson[label];
        }
        if (componentName === "NewMemberReportComponent") {
            return this.newMemberReportLangEnJson[label];
        }
        if (componentName === "POSSalesReportsComponent") {
            return this.pOSSalesReportLangEnJson[label];
        }
        if (componentName === "PurchaseHistoryReportsComponent") {
            return this.purchaseHistoryReportsLangEnJson[label];
        }
        if (componentName === "RequestManagementReportComponent") {
            return this.requestManagementReportsLangEnJson[label];
        }
        if (componentName === "SalesReportsComponent") {
            return this.salesReportsLangEnJson[label];
        }
        if (componentName === "TrainerSalesReportComponent") {
            return this.trainerSalesReportLangEnJson[label];
        }
        if (componentName === "TrainerClientsReportComponent") {
            return this.trainerClientsReportLangEnJson[label];
        }
        if (componentName === "TrainerSessionReportComponent") {
            return this.trainerSessionReportLangEnJson[label];
        }
        if (componentName === "TrainingAttendenceReportComponent") {
            return this.trainingAttendenceReportLangEnJson[label];
        }
        if (componentName === "UpcomingBirthdaysReportComponent") {
            return this.upcomingBirthdaysReportLangEnJson[label];
        }
        if (componentName === "UpcomingDuesReportComponent") {
            return this.upcomingDuesReportLangEnJson[label];
        }
        if (componentName === "UsersAttendanceReportComponent") {
            return this.usersAttendanceReportLangEnJson[label];
        }
        if (componentName === "ReportsComponent") {
            return this.reportsLangEnJson[label];
        }
        if (componentName === "FeeSubmissionRequestDetailComponent") {
            return this.feeSubmissionRequestDetailLangEnJson[label];
        }
        if (componentName === "MemberRequestDetailComponent") {
            return this.memberRequestDetailLangEnJson[label];
        }
        if (componentName === "RequestsManagementComponent") {
            return this.requestsManagementLangEnJson[label];
        }
        if (componentName === "PointOfSaleComponent") {
            return this.pointOfSaleLangEnJson[label];
        }
        if (componentName === "SaleOrdersComponent") {
            return this.saleOrdersLangEnJson[label];
        }
        if (componentName === "BranchComponent") {
            return this.branchLangEnJson[label];
        }
        if (componentName === "BranchesComponent") {
            return this.branchesLangEnJson[label];
        }
        if (componentName === "RegisterBranchFromCompanyComponent") {
            return this.registerBranchFromCompanyLangEnJson[label];
        }
        if (componentName === "CompaniesComponent") {
            return this.companiesLangEnJson[label];
        }
        if (componentName === "CompanyComponent") {
            return this.companyLangEnJson[label];
        }
        if (componentName === "UserPasswordComponent") {
            return this.userPasswordLangEnJson[label];
        }
        if (componentName === "PermissionComponent") {
            return this.permissionLangEnJson[label];
        }
        if (componentName === "PermissionsComponent") {
            return this.permissionsLangEnJson[label];
        }
        if (componentName === "RoleComponent") {
            return this.roleLangEnJson[label];
        }
        if (componentName === "RolesComponent") {
            return this.rolesLangEnJson[label];
        }
        if (componentName === "UserComponent") {
            return this.userLangEnJson[label];
        }
        if (componentName === "TrainerPackagesComponent") {
            return this.trainerPackagesLangEnJson[label];
        }
        if (componentName === "TrainerScheduleComponent") {
            return this.trainerScheduleLangEnJson[label];
        }
        if (componentName === "TrainerModuleSettingsComponent") {
            return this.trainerModuleSettingsLangEnJson[label];
        }
        if (componentName === "UsersComponent") {
            return this.usersLangEnJson[label];
        }
        if (componentName === "EmployeesPayoutComponent") {
            return this.employeesPayoutLangEnJson[label];
        }
        if (componentName === "ReceiptPrintComponent") {
            return this.receiptPrintLangEnJson[label];
        }
        if (componentName === "SingleReceiptPrintComponent") {
            return this.singleReceiptPrintLangEnJson[label];
        }
        if (componentName === "SingleReceiptEmailComponent") {
            return this.singleReceiptEmailLangEnJson[label];
        }
        if (componentName === "SignupComponent") {
            return this.signupLangEnJson[label];
        }
        if (componentName === "AddSingleSignupComponent") {
            return this.addSingleSignupLangEnJson[label];
        }
        if (componentName === "AddMultipleSignupComponent") {
            return this.addMultipleSignupLangEnJson[label];
        }
        if (componentName === "InActiveMemberReportComponent") {
            return this.inActiveMemberReportLangEnJson[label];
        }
        if (componentName === "EnquiryManagementReportComponent") {
            return this.enquiryManagementReportLangEnJson[label];
        }
        if (componentName === "AddSupplierComponent") {
            return this.addSupplierLangEnJson[label];
        }
        if (componentName === "PurchaseOrderComponent") {
            return this.purchaseOrderLangEnJson[label];
        }
        if (componentName === "PurchaseOrdersComponent") {
            return this.purchaseOrdersLangEnJson[label];
        }
        if (componentName === "SupplierListingComponent") {
            return this.supplierListingLangEnJson[label];
        }
        if (componentName === "MembersTrainingAttendenceComponent") {
            return this.membersTrainingAttendenceLangEnJson[label];
        }
        if (componentName === "MembersTrainingAttendanceViewComponent") {
            return this.membersTrainingAttendenceViewLangEnJson[label];
        }
        if (componentName === "AddVisitorComponent") {
            return this.addVisitorLangEnJson[label];
        }
        if (componentName === "VisitorDialogueComponent") {
            return this.visitorDialogueLangEnJson[label];
        }
        if (componentName === "VisitorRequestDetailComponent") {
            return this.visitorRequestDetailLangEnJson[label];
        }
        if (componentName === "FreezeRequestDetailComponent") {
            return this.freezeRequestDetailLangEnJson[label];
        }
        if (componentName === "VisitorReportComponent") {
            return this.visitorReportLangEnJson[label];
        }
        if (componentName === "GlobalComponent") {
            return this.globalLangEnJson[label];
        }
        if (componentName === "ClosingReportComponent") {
            return this.closingReportLangEnJson[label];
        }
        if (componentName === "UserInformationComponent") {
            return this.userInformationLangEnJson[label];
        }
        if (componentName === "NotificationComponent") {
            return this.notificationLangEnJson[label];
        }
        if (componentName === "NotificationsComponent") {
            return this.notificationsLangEnJson[label];
        }
        if (componentName === "AddTrainerComponent") {
            return this.addTrainerLangEnJson[label];
        }
        if (componentName === "TrainersComponent") {
            return this.trainersLangEnJson[label];
        }
        if (componentName === "AppFormFieldsComponent") {
            return this.appFormFieldsLangEnJson[label];
        }
        if (componentName === "TrainerAttendanceReportComponent") {
            return this.trainerAttendanceReportLangEnJson[label];
        }
        if (componentName === "TrainerDefaulterComponent") {
            return this.trainerDefaulterLangEnJson[label];
        }
        if (componentName === "SubscriptionDefaulterReportComponent") {
            return this.subscriptionDefaulterReportLangEnJson[label];
        }
        if (componentName === "ComplainsComponent") {
            return this.complainsLangEnJson[label];
        }
        if (componentName === "PermissionVisitorComponent") {
            return this.permissionVisitorLangEnJson[label];
        }
        if (componentName === "AddpackageBuilderComponent") {
            return this.addpackageBuilderLangEnJson[label];
        }
        if (componentName === "RegisterCompanyComponent") {
            return this.registerCompanyLangEnJson[label];
        }
        if (componentName === "AddServicesComponent") {
            return this.addServicesLangEnJson[label];
        }
        if (componentName === "TrainingServiceComponent") {
            return this.trainingServiceLangEnJson[label];
        }
        if (componentName === "ServicesComponent") {
            return this.servicesLangEnJson[label];
        }
        if (componentName === "SelfServiceComponent") {
            return this.selfServicesLangEnJson[label];
        }
        if (componentName === "AppRightpanelComponent") {
            return this.appRightpanelLangEnJson[label];
        }
        if (componentName === "TrainingSessionsComponent") {
            return this.trainingSessionsLangEnJson[label];
        }
        if (componentName === "SelfSessionsComponent") {
            return this.trainingSessionsLangEnJson[label];
        }
        if (componentName === "TrainerPayoutComponent") {
            return this.trainerPayoutLangEnJson[label];
        }
        if (componentName === "TrainerDashboardComponent") {
            return this.trainerDashboardLangEnJson[label];
        }
        if (componentName === "TrainingSessionAttdComponent") {
            return this.trainingSessionAttdLangEnJson[label];
        }
        if (componentName === "AppTopbarComponent") {
            return this.appTopbarLangEnJson[label];
        }
        if (componentName === "FeeCollectComponent") {
            return this.feeCollectLangEnJson[label];
        }
        if (componentName === "PaymentComponent") {
            return this.paymentLangEnJson[label];
        }
        if (componentName === "AppLoginComponent") {
            return this.appLoginLangEnJson[label];
        }
        if (componentName === "QuotationsComponent") {
            return this.quotationsLangEnJson[label];
        }
    }

    Arabic(label, componentName) {
        if (componentName === "DashboardComponent") {
            return this.dashboardLangArJson[label];
        }
        if (componentName === "VisitorsComponent") {
            return this.visitorsLangArJson[label];
        }
        if (componentName === "AddVisitorComponent") {
            return this.addVisitorLangArJson[label];
        }
        if (componentName === "VisitorDialogueComponent") {
            return this.visitorDialogueLangArJson[label];
        }
        if (componentName === "ActivityLogsComponent") {
            return this.activityLogsLangArJson[label];
        }
        if (componentName === "AssetDetailsComponent") {
            return this.assetDetailLangArJson[label];
        }
        if (componentName === "AddAssetComponent") {
            return this.addAssetLangArJson[label];
        }
        if (componentName === "AssetsComponent") {
            return this.assetsLangArJson[label];
        }
        if (componentName === "AttendanceListComponent") {
            return this.attendanceListLangArJson[label];
        }
        if (componentName === "AttendanceViewComponent") {
            return this.attendanceViewLangArJson[label];
        }
        if (componentName === "BookingComponent") {
            return this.bookingLangArJson[label];
        }
        if (componentName === "BookingsComponent") {
            return this.bookingsLangArJson[label];
        }
        if (componentName === "BookingSlotComponent") {
            return this.bookingSlotLangArJson[label];
        }
        if (componentName === "BookingSlotsComponent") {
            return this.bookingSlotsLangArJson[label];
        }
        if (componentName === "AddEmployeeComponent") {
            return this.addEmployeeLangArJson[label];
        }
        if (componentName === "EmployeesListingComponent") {
            return this.employeesListingLangArJson[label];
        }
        if (componentName === "AddEnquiryComponent") {
            return this.addEnquiryLangArJson[label];
        }
        if (componentName === "EnquiryListingComponent") {
            return this.enquiryListingLangArJson[label];
        }
        if (componentName === "FeeComponent") {
            return this.feeLangArJson[label];
        }
        if (componentName === "FeesComponent") {
            return this.feesLangArJson[label];
        }
        if (componentName === "PaySalaryToEmployeesComponent") {
            return this.paySalaryToEmployeesLangArJson[label];
        }
        if (componentName === "DesignationManagementComponent") {
            return this.designationManagementLangArJson[label];
        }
        if (componentName === "EmployeeSalaryManagementComponent") {
            return this.employeeSalaryManagementLangArJson[label];
        }
        if (componentName === "AddMembersComponent") {
            return this.addMembersLangArJson[label];
        }
        if (componentName === "CameraComponent") {
            return this.cameraLangArJson[label];
        }
        if (componentName === "AddFeeComponent") {
            return this.addFeeLangArJson[label];
        }
        if (componentName === "AddFeeMemberComponent") {
            return this.addFeeMemberLangArJson[label];
        }
        if (componentName === "BookTrainerComponent") {
            return this.bookTrainerLangArJson[label];
        }
        if (componentName === "SessionAttendanceReportComponent") {
            return this.sessionAttendanceReportLangArJson[label];
        }
        if (componentName === "SessionSalesReportComponent") {
            return this.sessionSalesReportLangArJson[label];
        }
        if (componentName === "SessionAttendanceComponent") {
            return this.sessionAttendanceLangArJson[label];
        }
        if (componentName === "AppPasswordComponent") {
            return this.appPasswordLangArJson[label];
        }
        if (componentName === "ExportDataComponent") {
            return this.exportDataLangArJson[label];
        }
        if (componentName === "FeesInvoiceComponent") {
            return this.feesInvoiceLangArJson[label];
        }
        if (componentName === "EmailConfirmationModalComponent") {
            return this.emailConfirmationModelLangArJson[label];
        }
        if (componentName === "InactiveMembersComponent") {
            return this.inactiveMembersLangArJson[label];
        }
        if (componentName === "MembersComponent") {
            return this.membersLangArJson[label];
        }
        if (componentName === "PackageBuilderComponent") {
            return this.packageBuilderLangArJson[label];
        }
        if (componentName === "PackageBuildersComponent") {
            return this.packageBuildersLangArJson[label];
        }
        if (componentName === "PettyCashComponent") {
            return this.pettyCashLangArJson[label];
        }
        if (componentName === "EmployeesPayoutComponent") {
            return this.employeesPayoutLangArJson[label];
        }
        if (componentName === "AddProductComponent") {
            return this.addProductLangArJson[label];
        }
        if (componentName === "ProductCategoriesComponent") {
            return this.productCategoriesLangArJson[label];
        }
        if (componentName === "ProductCategoryComponent") {
            return this.productCategoryLangArJson[label];
        }
        if (componentName === "ProductsListingComponent") {
            return this.productsListingLangArJson[label];
        }
        if (componentName === "UpdateStockCountComponent") {
            return this.updateStockCountLangArJson[label];
        }
        if (componentName === "ContactUsComponent") {
            return this.contactUsLangArJson[label];
        }
        if (componentName === "LoginLogsComponent") {
            return this.loginLogsLangArJson[label];
        }
        if (componentName === "ActiveMemberReportComponent") {
            return this.activeMemberReportLangArJson[label];
        }
        if (componentName === "AttendenceReportComponent") {
            return this.attendenceReportLangArJson[label];
        }
        if (componentName === "CheckInReportComponent") {
            return this.checkInReportLangArJson[label];
        }
        if (componentName === "DailyClosingReportComponent") {
            return this.dailyClosingReportLangArJson[label];
        }
        if (componentName === "DefaulterReportComponent") {
            return this.defaulterReportLangArJson[label];
        }
        if (componentName === "MemberReportComponent") {
            return this.memberReportLangArJson[label];
        }
        if (componentName === "NewMemberReportComponent") {
            return this.newMemberReportLangArJson[label];
        }
        if (componentName === "POSSalesReportsComponent") {
            return this.pOSSalesReportLangArJson[label];
        }
        if (componentName === "PurchaseHistoryReportsComponent") {
            return this.purchaseHistoryReportsLangArJson[label];
        }
        if (componentName === "RequestManagementReportComponent") {
            return this.requestManagementReportsLangArJson[label];
        }
        if (componentName === "SalesReportsComponent") {
            return this.salesReportsLangArJson[label];
        }
        if (componentName === "TrainerSalesReportComponent") {
            return this.trainerSalesReportLangArJson[label];
        }
        if (componentName === "TrainerClientsReportComponent") {
            return this.trainerClientsReportLangArJson[label];
        }
        if (componentName === "TrainerSessionReportComponent") {
            return this.trainerSessionReportLangArJson[label];
        }
        if (componentName === "TrainingAttendenceReportComponent") {
            return this.trainingAttendenceReportLangArJson[label];
        }
        if (componentName === "UpcomingBirthdaysReportComponent") {
            return this.upcomingBirthdaysReportLangArJson[label];
        }
        if (componentName === "UpcomingDuesReportComponent") {
            return this.upcomingDuesReportLangArJson[label];
        }
        if (componentName === "UsersAttendanceReportComponent") {
            return this.usersAttendanceReportLangArJson[label];
        }
        if (componentName === "ReportsComponent") {
            return this.reportsLangArJson[label];
        }
        if (componentName === "FeeSubmissionRequestDetailComponent") {
            return this.feeSubmissionRequestDetailLangArJson[label];
        }
        if (componentName === "MemberRequestDetailComponent") {
            return this.memberRequestDetailLangArJson[label];
        }
        if (componentName === "RequestsManagementComponent") {
            return this.requestsManagementLangArJson[label];
        }
        if (componentName === "PointOfSaleComponent") {
            return this.pointOfSaleLangArJson[label];
        }
        if (componentName === "SaleOrdersComponent") {
            return this.saleOrdersLangArJson[label];
        }
        if (componentName === "BranchComponent") {
            return this.branchLangArJson[label];
        }
        if (componentName === "BranchesComponent") {
            return this.branchesLangArJson[label];
        }
        if (componentName === "RegisterBranchFromCompanyComponent") {
            return this.registerBranchFromCompanyLangArJson[label];
        }
        if (componentName === "CompaniesComponent") {
            return this.companiesLangArJson[label];
        }
        if (componentName === "CompanyComponent") {
            return this.companyLangArJson[label];
        }
        if (componentName === "UserPasswordComponent") {
            return this.userPasswordLangArJson[label];
        }
        if (componentName === "PermissionComponent") {
            return this.permissionLangArJson[label];
        }
        if (componentName === "PermissionsComponent") {
            return this.permissionsLangArJson[label];
        }
        if (componentName === "RoleComponent") {
            return this.roleLangArJson[label];
        }
        if (componentName === "RolesComponent") {
            return this.rolesLangArJson[label];
        }
        if (componentName === "UserComponent") {
            return this.userLangArJson[label];
        }
        if (componentName === "TrainerPackagesComponent") {
            return this.trainerPackagesLangArJson[label];
        }
        if (componentName === "TrainerScheduleComponent") {
            return this.trainerScheduleLangArJson[label];
        }
        if (componentName === "TrainerModuleSettingsComponent") {
            return this.trainerModuleSettingsLangArJson[label];
        }
        if (componentName === "UsersComponent") {
            return this.usersLangArJson[label];
        }
        if (componentName === "ReceiptPrintComponent") {
            return this.receiptPrintLangArJson[label];
        }
        if (componentName === "SingleReceiptPrintComponent") {
            return this.singleReceiptPrintLangArJson[label];
        }
        if (componentName === "SingleReceiptEmailComponent") {
            return this.singleReceiptEmailLangArJson[label];
        }
        if (componentName === "SignupComponent") {
            return this.signupLangArJson[label];
        }
        if (componentName === "AddSingleSignupComponent") {
            return this.addSingleSignupLangArJson[label];
        }
        if (componentName === "AddMultipleSignupComponent") {
            return this.addMultipleSignupLangArJson[label];
        }
        if (componentName === "InActiveMemberReportComponent") {
            return this.inActiveMemberReportLangArJson[label];
        }
        if (componentName === "EnquiryManagementReportComponent") {
            return this.enquiryManagementReportLangArJson[label];
        }
        if (componentName === "AddSupplierComponent") {
            return this.addSupplierLangArJson[label];
        }
        if (componentName === "PurchaseOrderComponent") {
            return this.purchaseOrderLangArJson[label];
        }
        if (componentName === "PurchaseOrdersComponent") {
            return this.purchaseOrdersLangArJson[label];
        }
        if (componentName === "SupplierListingComponent") {
            return this.supplierListingLangArJson[label];
        }
        if (componentName === "MembersTrainingAttendenceComponent") {
            return this.membersTrainingAttendenceLangArJson[label];
        }
        if (componentName === "MembersTrainingAttendanceViewComponent") {
            return this.membersTrainingAttendenceViewLangArJson[label];
        }
        if (componentName === "VisitorRequestDetailComponent") {
            return this.visitorRequestDetailLangArJson[label];
        }
        if (componentName === "FreezeRequestDetailComponent") {
            return this.freezeRequestDetailLangArJson[label];
        }
        if (componentName === "VisitorReportComponent") {
            return this.visitorReportLangArJson[label];
        }
        if (componentName === "GlobalComponent") {
            return this.globalLangArJson[label];
        }
        if (componentName === "ClosingReportComponent") {
            return this.closingReportLangArJson[label];
        }
        if (componentName === "UserInformationComponent") {
            return this.userInformationLangArJson[label];
        }
        if (componentName === "NotificationComponent") {
            return this.notificationLangArJson[label];
        }
        if (componentName === "NotificationsComponent") {
            return this.notificationsLangArJson[label];
        }
        if (componentName === "AddTrainerComponent") {
            return this.addTrainerLangArJson[label];
        }
        if (componentName === "TrainersComponent") {
            return this.trainersLangArJson[label];
        }
        if (componentName === "AppFormFieldsComponent") {
            return this.appFormFieldsLangArJson[label];
        }
        if (componentName === "TrainerAttendanceReportComponent") {
            return this.trainerAttendanceReportLangArJson[label];
        }
        if (componentName === "TrainerDefaulterComponent") {
            return this.trainerDefaulterLangArJson[label];
        }
        if (componentName === "SubscriptionDefaulterReportComponent") {
            return this.subscriptionDefaulterReportLangArJson[label];
        }
        if (componentName === "ComplainsComponent") {
            return this.complainsLangArJson[label];
        }
        if (componentName === "PermissionVisitorComponent") {
            return this.permissionVisitorLangArJson[label];
        }
        if (componentName === "AddpackageBuilderComponent") {
            return this.addpackageBuilderLangArJson[label];
        }
        if (componentName === "RegisterCompanyComponent") {
            return this.registerCompanyLangArJson[label];
        }
        if (componentName === "AddServicesComponent") {
            return this.addServicesLangArJson[label];
        }
        if (componentName === "TrainingServiceComponent") {
            return this.trainingServiceLangArJson[label];
        }
        if (componentName === "ServicesComponent") {
            return this.servicesLangArJson[label];
        }
        if (componentName === "SelfServiceComponent") {
            return this.selfServicesLangArJson[label];
        }
        if (componentName === "AppRightpanelComponent") {
            return this.appRightpanelLangArJson[label];
        }
        if (componentName === "TrainingSessionsComponent") {
            return this.trainingSessionsLangArJson[label];
        }
        if (componentName === "SelfSessionsComponent") {
            return this.trainingSessionsLangArJson[label];
        }
        if (componentName === "TrainerPayoutComponent") {
            return this.trainerPayoutLangArJson[label];
        }
        if (componentName === "TrainerDashboardComponent") {
            return this.trainerDashboardLangArJson[label];
        }
        if (componentName === "TrainingSessionAttdComponent") {
            return this.trainingSessionAttdLangArJson[label];
        }
        if (componentName === "AppTopbarComponent") {
            return this.appTopbarLangArJson[label];
        }
        if (componentName === "FeeCollectComponent") {
            return this.feeCollectLangArJson[label];
        }
        if (componentName === "PaymentComponent") {
            return this.paymentLangArJson[label];
        }
        if (componentName === "AppLoginComponent") {
            return this.appLoginLangArJson[label];
        }
        if (componentName === "QuotationsComponent") {
            return this.quotationsLangArJson[label];
        }
    }

    Urdu(label, componentName) {
        if (componentName === "DashboardComponent") {
            return this.dashboardLangUrJson[label];
        }
        if (componentName === "VisitorsComponent") {
            return this.visitorsLangUrJson[label];
        }
        if (componentName === "AddVisitorComponent") {
            return this.addVisitorLangUrJson[label];
        }
        if (componentName === "VisitorDialogueComponent") {   // Not finsished completely
            return this.visitorDialogueLangUrJson[label];
        }
        if (componentName === "ActivityLogsComponent") {
            return this.activityLogsLangUrJson[label];
        }
        if (componentName === "AssetDetailsComponent") {
            return this.assetDetailLangUrJson[label];
        }
        if (componentName === "AddAssetComponent") {
            return this.addAssetLangUrJson[label];
        }
        if (componentName === "AssetsComponent") {
            return this.assetsLangUrJson[label];
        }
        if (componentName === "AttendanceListComponent") {
            return this.attendanceListLangUrJson[label];
        }
        if (componentName === "AttendanceViewComponent") {
            return this.attendanceViewLangUrJson[label];
        }
        if (componentName === "BookingComponent") {
            return this.bookingLangUrJson[label];
        }
        if (componentName === "BookingsComponent") {
            return this.bookingsLangUrJson[label];
        }
        if (componentName === "BookingSlotComponent") {
            return this.bookingSlotLangUrJson[label];
        }
        if (componentName === "BookingSlotsComponent") {
            return this.bookingSlotsLangUrJson[label];
        }
        if (componentName === "AddEmployeeComponent") {
            return this.addEmployeeLangUrJson[label];
        }
        if (componentName === "EmployeesListingComponent") {
            return this.employeesListingLangUrJson[label];
        }
        if (componentName === "AddEnquiryComponent") {
            return this.addEnquiryLangUrJson[label];
        }
        if (componentName === "EnquiryListingComponent") {
            return this.enquiryListingLangUrJson[label];
        }
        if (componentName === "FeeComponent") {
            return this.feeLangUrJson[label];
        }
        if (componentName === "FeesComponent") {
            return this.feesLangUrJson[label];
        }
        if (componentName === "PaySalaryToEmployeesComponent") {
            return this.paySalaryToEmployeesLangUrJson[label];
        }
        if (componentName === "DesignationManagementComponent") {
            return this.designationManagementLangUrJson[label];
        }
        if (componentName === "EmployeeSalaryManagementComponent") {
            return this.employeeSalaryManagementLangUrJson[label];
        }
        if (componentName === "AddMembersComponent") {
            return this.addMembersLangUrJson[label];
        }
        if (componentName === "CameraComponent") {
            return this.cameraLangUrJson[label];
        }
        if (componentName === "AddFeeComponent") {
            return this.addFeeLangUrJson[label];
        }
        if (componentName === "AddFeeMemberComponent") {
            return this.addFeeMemberLangUrJson[label];
        }
        if (componentName === "BookTrainerComponent") {
            return this.bookTrainerLangUrJson[label];
        }
        if (componentName === "SessionAttendanceReportComponent") {
            return this.sessionAttendanceReportLangUrJson[label];
        }
        if (componentName === "SessionSalesReportComponent") {
            return this.sessionSalesReportLangUrJson[label];
        }
        if (componentName === "SessionAttendanceComponent") {
            return this.sessionAttendanceLangUrJson[label];
        }
        if (componentName === "EmployeesPayoutComponent") {
            return this.employeesPayoutLangUrJson[label];
        }
        if (componentName === "AppPasswordComponent") {
            return this.appPasswordLangUrJson[label];
        }
        if (componentName === "ExportDataComponent") {
            return this.exportDataLangUrJson[label];
        }
        if (componentName === "FeesInvoiceComponent") {
            return this.feesInvoiceLangUrJson[label];
        }
        if (componentName === "EmailConfirmationModalComponent") {
            return this.emailConfirmationModelLangUrJson[label];
        }
        if (componentName === "InactiveMembersComponent") {
            return this.inactiveMembersLangUrJson[label];
        }
        if (componentName === "MembersComponent") {
            return this.membersLangUrJson[label];
        }
        if (componentName === "PackageBuilderComponent") {
            return this.packageBuilderLangUrJson[label];
        }
        if (componentName === "PackageBuildersComponent") {
            return this.packageBuildersLangUrJson[label];
        }
        if (componentName === "PettyCashComponent") {
            return this.pettyCashLangUrJson[label];
        }
        if (componentName === "AddProductComponent") {
            return this.addProductLangUrJson[label];
        }
        if (componentName === "ProductCategoriesComponent") {
            return this.productCategoriesLangUrJson[label];
        }
        if (componentName === "ProductCategoryComponent") {
            return this.productCategoryLangUrJson[label];
        }
        if (componentName === "ProductsListingComponent") {
            return this.productsListingLangUrJson[label];
        }
        if (componentName === "UpdateStockCountComponent") {
            return this.updateStockCountLangUrJson[label];
        }
        if (componentName === "ContactUsComponent") {
            return this.contactUsLangUrJson[label];
        }
        if (componentName === "LoginLogsComponent") {
            return this.loginLogsLangUrJson[label];
        }
        if (componentName === "ActiveMemberReportComponent") {
            return this.activeMemberReportLangUrJson[label];
        }
        if (componentName === "AttendenceReportComponent") {
            return this.attendenceReportLangUrJson[label];
        }
        if (componentName === "CheckInReportComponent") {
            return this.checkInReportLangUrJson[label];
        }
        if (componentName === "DailyClosingReportComponent") {
            return this.dailyClosingReportLangUrJson[label];
        }
        if (componentName === "DefaulterReportComponent") {
            return this.defaulterReportLangUrJson[label];
        }
        if (componentName === "MemberReportComponent") {
            return this.memberReportLangUrJson[label];
        }
        if (componentName === "NewMemberReportComponent") {
            return this.newMemberReportLangUrJson[label];
        }
        if (componentName === "POSSalesReportsComponent") {
            return this.pOSSalesReportLangUrJson[label];
        }
        if (componentName === "PurchaseHistoryReportsComponent") {
            return this.purchaseHistoryReportsLangUrJson[label];
        }
        if (componentName === "RequestManagementReportComponent") {
            return this.requestManagementReportsLangUrJson[label];
        }
        if (componentName === "SalesReportsComponent") {
            return this.salesReportsLangUrJson[label];
        }
        if (componentName === "TrainerSalesReportComponent") {
            return this.trainerSalesReportLangUrJson[label];
        }
        if (componentName === "TrainerClientsReportComponent") {
            return this.trainerClientsReportLangUrJson[label];
        }
        if (componentName === "TrainerSessionReportComponent") {
            return this.trainerSessionReportLangUrJson[label];
        }
        if (componentName === "TrainingAttendenceReportComponent") {
            return this.trainingAttendenceReportLangUrJson[label];
        }
        if (componentName === "UpcomingBirthdaysReportComponent") {
            return this.upcomingBirthdaysReportLangUrJson[label];
        }
        if (componentName === "UpcomingDuesReportComponent") {
            return this.upcomingDuesReportLangUrJson[label];
        }
        if (componentName === "UsersAttendanceReportComponent") {
            return this.usersAttendanceReportLangUrJson[label];
        }
        if (componentName === "ReportsComponent") {
            return this.reportsLangUrJson[label];
        }
        if (componentName === "FeeSubmissionRequestDetailComponent") {
            return this.feeSubmissionRequestDetailLangUrJson[label];
        }
        if (componentName === "MemberRequestDetailComponent") {
            return this.memberRequestDetailLangUrJson[label];
        }
        if (componentName === "RequestsManagementComponent") {
            return this.requestsManagementLangUrJson[label];
        }
        if (componentName === "PointOfSaleComponent") {
            return this.pointOfSaleLangUrJson[label];
        }
        if (componentName === "SaleOrdersComponent") {
            return this.saleOrdersLangUrJson[label];
        }
        if (componentName === "BranchComponent") {
            return this.branchLangUrJson[label];
        }
        if (componentName === "BranchesComponent") {
            return this.branchesLangUrJson[label];
        }
        if (componentName === "RegisterBranchFromCompanyComponent") {
            return this.registerBranchFromCompanyLangUrJson[label];
        }
        if (componentName === "CompaniesComponent") {
            return this.companiesLangUrJson[label];
        }
        if (componentName === "CompanyComponent") {
            return this.companyLangUrJson[label];
        }
        if (componentName === "UserPasswordComponent") {
            return this.userPasswordLangUrJson[label];
        }
        if (componentName === "PermissionComponent") {
            return this.permissionLangUrJson[label];
        }
        if (componentName === "PermissionsComponent") {
            return this.permissionsLangUrJson[label];
        }
        if (componentName === "RoleComponent") {
            return this.roleLangUrJson[label];
        }
        if (componentName === "RolesComponent") {
            return this.rolesLangUrJson[label];
        }
        if (componentName === "UserComponent") {
            return this.userLangUrJson[label];
        }
        if (componentName === "TrainerPackagesComponent") {
            return this.trainerPackagesLangUrJson[label];
        }
        if (componentName === "TrainerScheduleComponent") {
            return this.trainerScheduleLangUrJson[label];
        }
        if (componentName === "TrainerModuleSettingsComponent") {
            return this.trainerModuleSettingsLangUrJson[label];
        }
        if (componentName === "UsersComponent") {
            return this.usersLangUrJson[label];
        }
        if (componentName === "ReceiptPrintComponent") {
            return this.receiptPrintLangUrJson[label];
        }
        if (componentName === "SingleReceiptPrintComponent") {
            return this.singleReceiptPrintLangUrJson[label];
        }
        if (componentName === "SingleReceiptEmailComponent") {
            return this.singleReceiptEmailLangUrJson[label];
        }
        if (componentName === "SignupComponent") {
            return this.signupLangUrJson[label];
        }
        if (componentName === "AddSingleSignupComponent") {
            return this.addSingleSignupLangUrJson[label];
        }
        if (componentName === "AddMultipleSignupComponent") {
            return this.addMultipleSignupLangUrJson[label];
        }
        if (componentName === "InActiveMemberReportComponent") {
            return this.inActiveMemberReportLangUrJson[label];
        }
        if (componentName === "EnquiryManagementReportComponent") {
            return this.enquiryManagementReportLangUrJson[label];
        }
        if (componentName === "AddSupplierComponent") {
            return this.addSupplierLangUrJson[label];
        }
        if (componentName === "PurchaseOrderComponent") {
            return this.purchaseOrderLangUrJson[label];
        }
        if (componentName === "PurchaseOrdersComponent") {
            return this.purchaseOrdersLangUrJson[label];
        }
        if (componentName === "SupplierListingComponent") {
            return this.supplierListingLangUrJson[label];
        }
        if (componentName === "MembersTrainingAttendenceComponent") {
            return this.membersTrainingAttendenceLangUrJson[label];
        }
        if (componentName === "MembersTrainingAttendanceViewComponent") {
            return this.membersTrainingAttendenceViewLangUrJson[label];
        }
        if (componentName === "VisitorRequestDetailComponent") {
            return this.visitorRequestDetailLangUrJson[label];
        }
        if (componentName === "FreezeRequestDetailComponent") {
            return this.freezeRequestDetailLangUrJson[label];
        }
        if (componentName === "VisitorReportComponent") {
            return this.visitorReportLangUrJson[label];
        }
        if (componentName === "GlobalComponent") {
            return this.globalLangUrJson[label];
        }
        if (componentName === "ClosingReportComponent") {
            return this.closingReportLangUrJson[label];
        }
        if (componentName === "UserInformationComponent") {
            return this.userInformationLangUrJson[label];
        }
        if (componentName === "NotificationComponent") {
            return this.notificationLangUrJson[label];
        }
        if (componentName === "NotificationsComponent") {
            return this.notificationsLangUrJson[label];
        }
        if (componentName === "AddTrainerComponent") {
            return this.addTrainerLangUrJson[label];
        }
        if (componentName === "TrainersComponent") {
            return this.trainersLangUrJson[label];
        }
        if (componentName === "AppFormFieldsComponent") {
            return this.appFormFieldsLangUrJson[label];
        }
        if (componentName === "TrainerAttendanceReportComponent") {
            return this.trainerAttendanceReportLangUrJson[label];
        }
        if (componentName === "TrainerDefaulterComponent") {
            return this.trainerDefaulterLangUrJson[label];
        }
        if (componentName === "SubscriptionDefaulterReportComponent") {
            return this.subscriptionDefaulterReportLangUrJson[label];
        }
        if (componentName === "ComplainsComponent") {
            return this.complainsLangUrJson[label];
        }
        if (componentName === "PermissionVisitorComponent") {
            return this.permissionVisitorLangUrJson[label];
        }
        if (componentName === "AddpackageBuilderComponent") {
            return this.addpackageBuilderLangUrJson[label];
        }
        if (componentName === "RegisterCompanyComponent") {
            return this.registerCompanyLangUrJson[label];
        }
        if (componentName === "AddServicesComponent") {
            return this.addServicesLangUrJson[label];
        }
        if (componentName === "TrainingServiceComponent") {
            return this.trainingServiceLangUrJson[label];
        }
        if (componentName === "ServicesComponent") {
            return this.servicesLangUrJson[label];
        }
        if (componentName === "SelfServiceComponent") {
            return this.selfServicesLangUrJson[label];
        }
        if (componentName === "AppRightpanelComponent") {
            return this.appRightpanelLangUrJson[label];
        }
        if (componentName === "TrainingSessionsComponent") {
            return this.trainingSessionsLangUrJson[label];
        }
        if (componentName === "SelfSessionsComponent") {
            return this.trainingSessionsLangUrJson[label];
        }
        if (componentName === "TrainerPayoutComponent") {
            return this.trainerPayoutLangUrJson[label];
        }
        if (componentName === "TrainerDashboardComponent") {
            return this.trainerDashboardLangUrJson[label];
        }
        if (componentName === "TrainingSessionAttdComponent") {
            return this.trainingSessionAttdLangUrJson[label];
        }
        if (componentName === "AppTopbarComponent") {
            return this.appTopbarLangUrJson[label];
        }
        if (componentName === "FeeCollectComponent") {
            return this.feeCollectLangUrJson[label];
        }
        if (componentName === "PaymentComponent") {
            return this.paymentLangUrJson[label];
        }
        if (componentName === "AppLoginComponent") {
            return this.appLoginLangUrJson[label];
        }
        if (componentName === "QuotationsComponent") {
            return this.quotationsLangUrJson[label];
        }
    }
    Pashto(label, componentName) {
        if (componentName === "DashboardComponent") {
            return this.dashboardLangPsJson[label];
        }
        if (componentName === "VisitorsComponent") {
            return this.visitorsLangPsJson[label];
        }
        if (componentName === "AddVisitorComponent") {
            return this.addVisitorLangPsJson[label];
        }
        if (componentName === "VisitorDialogueComponent") {   // Not finsished completely
            return this.visitorDialogueLangPsJson[label];
        }
        if (componentName === "ActivityLogsComponent") {
            return this.activityLogsLangPsJson[label];
        }
        if (componentName === "AssetDetailsComponent") {
            return this.assetDetailLangPsJson[label];
        }
        if (componentName === "AddAssetComponent") {
            return this.addAssetLangPsJson[label];
        }
        if (componentName === "AssetsComponent") {
            return this.assetsLangPsJson[label];
        }
        if (componentName === "AttendanceListComponent") {
            return this.attendanceListLangPsJson[label];
        }
        if (componentName === "AttendanceViewComponent") {
            return this.attendanceViewLangPsJson[label];
        }
        if (componentName === "BookingComponent") {
            return this.bookingLangPsJson[label];
        }
        if (componentName === "BookingsComponent") {
            return this.bookingsLangPsJson[label];
        }
        if (componentName === "BookingSlotComponent") {
            return this.bookingSlotLangPsJson[label];
        }
        if (componentName === "BookingSlotsComponent") {
            return this.bookingSlotsLangPsJson[label];
        }
        if (componentName === "AddEmployeeComponent") {
            return this.addEmployeeLangPsJson[label];
        }
        if (componentName === "EmployeesListingComponent") {
            return this.employeesListingLangPsJson[label];
        }
        if (componentName === "AddEnquiryComponent") {
            return this.addEnquiryLangPsJson[label];
        }
        if (componentName === "EnquiryListingComponent") {
            return this.enquiryListingLangPsJson[label];
        }
        if (componentName === "FeeComponent") {
            return this.feeLangPsJson[label];
        }
        if (componentName === "FeesComponent") {
            return this.feesLangPsJson[label];
        }
        if (componentName === "PaySalaryToEmployeesComponent") {
            return this.paySalaryToEmployeesLangPsJson[label];
        }
        if (componentName === "DesignationManagementComponent") {
            return this.designationManagementLangPsJson[label];
        }
        if (componentName === "EmployeeSalaryManagementComponent") {
            return this.employeeSalaryManagementLangPsJson[label];
        }
        if (componentName === "AddMembersComponent") {
            return this.addMembersLangPsJson[label];
        }
        if (componentName === "CameraComponent") {
            return this.cameraLangPsJson[label];
        }
        if (componentName === "AddFeeComponent") {
            return this.addFeeLangPsJson[label];
        }
        if (componentName === "AddFeeMemberComponent") {
            return this.addFeeMemberLangPsJson[label];
        }
        if (componentName === "BookTrainerComponent") {
            return this.bookTrainerLangPsJson[label];
        }
        if (componentName === "SessionAttendanceReportComponent") {
            return this.sessionAttendanceReportLangPsJson[label];
        }
        if (componentName === "SessionSalesReportComponent") {
            return this.sessionSalesReportLangPsJson[label];
        }
        if (componentName === "SessionAttendanceComponent") {
            return this.sessionAttendanceLangPsJson[label];
        }
        if (componentName === "AppPasswordComponent") {
            return this.appPasswordLangPsJson[label];
        }
        if (componentName === "ExportDataComponent") {
            return this.exportDataLangPsJson[label];
        }
        if (componentName === "FeesInvoiceComponent") {
            return this.feesInvoiceLangPsJson[label];
        }
        if (componentName === "EmailConfirmationModalComponent") {
            return this.emailConfirmationModelLangPsJson[label];
        }
        if (componentName === "InactiveMembersComponent") {
            return this.inactiveMembersLangPsJson[label];
        }
        if (componentName === "MembersComponent") {
            return this.membersLangPsJson[label];
        }
        if (componentName === "PackageBuilderComponent") {
            return this.packageBuilderLangPsJson[label];
        }
        if (componentName === "PackageBuildersComponent") {
            return this.packageBuildersLangPsJson[label];
        }
        if (componentName === "PettyCashComponent") {
            return this.pettyCashLangPsJson[label];
        }
        if (componentName === "AddProductComponent") {
            return this.addProductLangPsJson[label];
        }
        if (componentName === "ProductCategoriesComponent") {
            return this.productCategoriesLangPsJson[label];
        }
        if (componentName === "ProductCategoryComponent") {
            return this.productCategoryLangPsJson[label];
        }
        if (componentName === "ProductsListingComponent") {
            return this.productsListingLangPsJson[label];
        }
        if (componentName === "UpdateStockCountComponent") {
            return this.updateStockCountLangPsJson[label];
        }
        if (componentName === "ContactUsComponent") {
            return this.contactUsLangPsJson[label];
        }
        if (componentName === "LoginLogsComponent") {
            return this.loginLogsLangPsJson[label];
        }
        if (componentName === "ActiveMemberReportComponent") {
            return this.activeMemberReportLangPsJson[label];
        }
        if (componentName === "AttendenceReportComponent") {
            return this.attendenceReportLangPsJson[label];
        }
        if (componentName === "CheckInReportComponent") {
            return this.checkInReportLangPsJson[label];
        }
        if (componentName === "DailyClosingReportComponent") {
            return this.dailyClosingReportLangPsJson[label];
        }
        if (componentName === "DefaulterReportComponent") {
            return this.defaulterReportLangPsJson[label];
        }
        if (componentName === "MemberReportComponent") {
            return this.memberReportLangPsJson[label];
        }
        if (componentName === "NewMemberReportComponent") {
            return this.newMemberReportLangPsJson[label];
        }
        if (componentName === "POSSalesReportsComponent") {
            return this.pOSSalesReportLangPsJson[label];
        }
        if (componentName === "PurchaseHistoryReportsComponent") {
            return this.purchaseHistoryReportsLangPsJson[label];
        }
        if (componentName === "RequestManagementReportComponent") {
            return this.requestManagementReportsLangPsJson[label];
        }
        if (componentName === "SalesReportsComponent") {
            return this.salesReportsLangPsJson[label];
        }
        if (componentName === "TrainerSalesReportComponent") {
            return this.trainerSalesReportLangPsJson[label];
        }
        if (componentName === "TrainerClientsReportComponent") {
            return this.trainerClientsReportLangPsJson[label];
        }
        if (componentName === "TrainerSessionReportComponent") {
            return this.trainerSessionReportLangPsJson[label];
        }
        if (componentName === "TrainingAttendenceReportComponent") {
            return this.trainingAttendenceReportLangPsJson[label];
        }
        if (componentName === "UpcomingBirthdaysReportComponent") {
            return this.upcomingBirthdaysReportLangPsJson[label];
        }
        if (componentName === "UpcomingDuesReportComponent") {
            return this.upcomingDuesReportLangPsJson[label];
        }
        if (componentName === "UsersAttendanceReportComponent") {
            return this.usersAttendanceReportLangPsJson[label];
        }
        if (componentName === "ReportsComponent") {
            return this.reportsLangPsJson[label];
        }
        if (componentName === "FeeSubmissionRequestDetailComponent") {
            return this.feeSubmissionRequestDetailLangPsJson[label];
        }
        if (componentName === "MemberRequestDetailComponent") {
            return this.memberRequestDetailLangPsJson[label];
        }
        if (componentName === "RequestsManagementComponent") {
            return this.requestsManagementLangPsJson[label];
        }
        if (componentName === "PointOfSaleComponent") {
            return this.pointOfSaleLangPsJson[label];
        }
        if (componentName === "SaleOrdersComponent") {
            return this.saleOrdersLangPsJson[label];
        }
        if (componentName === "BranchComponent") {
            return this.branchLangPsJson[label];
        }
        if (componentName === "BranchesComponent") {
            return this.branchesLangPsJson[label];
        }
        if (componentName === "RegisterBranchFromCompanyComponent") {
            return this.registerBranchFromCompanyLangPsJson[label];
        }
        if (componentName === "CompaniesComponent") {
            return this.companiesLangPsJson[label];
        }
        if (componentName === "CompanyComponent") {
            return this.companyLangPsJson[label];
        }
        if (componentName === "UserPasswordComponent") {
            return this.userPasswordLangPsJson[label];
        }
        if (componentName === "PermissionComponent") {
            return this.permissionLangPsJson[label];
        }
        if (componentName === "PermissionsComponent") {
            return this.permissionsLangPsJson[label];
        }
        if (componentName === "RoleComponent") {
            return this.roleLangPsJson[label];
        }
        if (componentName === "RolesComponent") {
            return this.rolesLangPsJson[label];
        }
        if (componentName === "UserComponent") {
            return this.userLangPsJson[label];
        }
        if (componentName === "TrainerPackagesComponent") {
            return this.trainerPackagesLangPsJson[label];
        }
        if (componentName === "TrainerScheduleComponent") {
            return this.trainerScheduleLangPsJson[label];
        }
        if (componentName === "TrainerModuleSettingsComponent") {
            return this.trainerModuleSettingsLangPsJson[label];
        }
        if (componentName === "UsersComponent") {
            return this.usersLangPsJson[label];
        }
        if (componentName === "EmployeesPayoutComponent") {
            return this.employeesPayoutLangPsJson[label];
        }
        if (componentName === "ReceiptPrintComponent") {
            return this.receiptPrintLangPsJson[label];
        }
        if (componentName === "SingleReceiptPrintComponent") {
            return this.singleReceiptPrintLangPsJson[label];
        }
        if (componentName === "SingleReceiptEmailComponent") {
            return this.singleReceiptEmailLangPsJson[label];
        }
        if (componentName === "SignupComponent") {
            return this.signupLangPsJson[label];
        }
        if (componentName === "AddSingleSignupComponent") {
            return this.addSingleSignupLangPsJson[label];
        }
        if (componentName === "AddMultipleSignupComponent") {
            return this.addMultipleSignupLangPsJson[label];
        }
        if (componentName === "InActiveMemberReportComponent") {
            return this.inActiveMemberReportLangPsJson[label];
        }
        if (componentName === "EnquiryManagementReportComponent") {
            return this.enquiryManagementReportLangPsJson[label];
        }
        if (componentName === "AddSupplierComponent") {
            return this.addSupplierLangPsJson[label];
        }
        if (componentName === "PurchaseOrderComponent") {
            return this.purchaseOrderLangPsJson[label];
        }
        if (componentName === "PurchaseOrdersComponent") {
            return this.purchaseOrdersLangPsJson[label];
        }
        if (componentName === "SupplierListingComponent") {
            return this.supplierListingLangPsJson[label];
        }
        if (componentName === "MembersTrainingAttendenceComponent") {
            return this.membersTrainingAttendenceLangPsJson[label];
        }
        if (componentName === "MembersTrainingAttendanceViewComponent") {
            return this.membersTrainingAttendenceViewLangPsJson[label];
        }
        if (componentName === "VisitorRequestDetailComponent") {
            return this.visitorRequestDetailLangPsJson[label];
        }
        if (componentName === "FreezeRequestDetailComponent") {
            return this.freezeRequestDetailLangPsJson[label];
        }
        if (componentName === "VisitorReportComponent") {
            return this.visitorReportLangPsJson[label];
        }
        if (componentName === "GlobalComponent") {
            return this.globalLangPsJson[label];
        }
        if (componentName === "ClosingReportComponent") {
            return this.closingReportLangPsJson[label];
        }
        if (componentName === "UserInformationComponent") {
            return this.userInformationLangPsJson[label];
        }
        if (componentName === "NotificationComponent") {
            return this.notificationLangPsJson[label];
        }
        if (componentName === "NotificationsComponent") {
            return this.notificationsLangPsJson[label];
        }
        if (componentName === "AddTrainerComponent") {
            return this.addTrainerLangPsJson[label];
        }
        if (componentName === "TrainersComponent") {
            return this.trainersLangPsJson[label];
        }
        if (componentName === "AppFormFieldsComponent") {
            return this.appFormFieldsLangPsJson[label];
        }
        if (componentName === "TrainerAttendanceReportComponent") {
            return this.trainerAttendanceReportLangPsJson[label];
        }
        if (componentName === "TrainerDefaulterComponent") {
            return this.trainerDefaulterLangPsJson[label];
        }
        if (componentName === "SubscriptionDefaulterReportComponent") {
            return this.subscriptionDefaulterReportLangPsJson[label];
        }
        if (componentName === "ComplainsComponent") {
            return this.complainsLangPsJson[label];
        }
        if (componentName === "PermissionVisitorComponent") {
            return this.permissionVisitorLangPsJson[label];
        }
        if (componentName === "AddpackageBuilderComponent") {
            return this.addpackageBuilderLangPsJson[label];
        }
        if (componentName === "RegisterCompanyComponent") {
            return this.registerCompanyLangPsJson[label];
        }
        if (componentName === "AddServicesComponent") {
            return this.addServicesLangPsJson[label];
        }
        if (componentName === "TrainingServiceComponent") {
            return this.trainingServiceLangPsJson[label];
        }
        if (componentName === "ServicesComponent") {
            return this.servicesLangPsJson[label];
        }
        if (componentName === "SelfServiceComponent") {
            return this.selfServicesLangPsJson[label];
        }
        if (componentName === "AppRightpanelComponent") {
            return this.appRightpanelLangPsJson[label];
        }
        if (componentName === "TrainingSessionsComponent") {
            return this.trainingSessionsLangPsJson[label];
        }
        if (componentName === "TrainerPayoutComponent") {
            return this.trainerPayoutLangPsJson[label];
        }
        if (componentName === "TrainerDashboardComponent") {
            return this.trainerDashboardLangPsJson[label];
        }
        if (componentName === "TrainingSessionAttdComponent") {
            return this.trainingSessionAttdLangPsJson[label];
        }
        if (componentName === "AppTopbarComponent") {
            return this.appTopbarLangPsJson[label];
        }
        if (componentName === "FeeCollectComponent") {
            return this.feeCollectLangPsJson[label];
        }
        if (componentName === "PaymentComponent") {
            return this.paymentLangPsJson[label];
        }
        if (componentName === "AppLoginComponent") {
            return this.appLoginLangPsJson[label];
        }
        if (componentName === "QuotationsComponent") {
            return this.quotationsLangPsJson[label];
        }
    }


    GetCurrentLanguage(componentName, label) {
        if (this.lang === "en") {
            return this.English(label, componentName);
        }
        else if (this.lang === "ar") {
            return this.Arabic(label, componentName);
        }
        else if (this.lang === "ur") {
            return this.Urdu(label, componentName);
        }
        else if (this.lang === "ps") {
            return this.Pashto(label, componentName);
        }
        else {
            return this.English(label, componentName);
        }
    }
}